export const ICON_DROPDOWN_OPTIONS = [
  {
    label: 'No Icon Selected',
    value: '',
  },
];

const tempIcons = {
  selection: [
    {
      order: 2347,
      name: 'code',
      prevSize: 32,
      ligatures: 'code',
    },
    {
      order: 2348,
      name: 'grid',
      prevSize: 32,
      ligatures: 'grid',
    },
    {
      order: 2349,
      name: 'arrow_down',
      prevSize: 32,
      ligatures: 'arrow_down',
    },
    {
      order: 2350,
      name: 'arrow_left',
      prevSize: 32,
      ligatures: 'arrow_left',
    },
    {
      order: 2351,
      name: 'arrow_right',
      prevSize: 32,
      ligatures: 'arrow_right',
    },
    {
      order: 2352,
      name: 'arrow_up',
      prevSize: 32,
      ligatures: 'arrow_up',
    },
    {
      order: 2353,
      name: 'arrow_diagonal_left',
      prevSize: 32,
      ligatures: 'arrow_diagonal_left',
    },
    {
      order: 2354,
      name: 'arrow_return',
      prevSize: 32,
      ligatures: 'arrow_return',
    },
    {
      order: 2355,
      name: 'chevron_down',
      prevSize: 32,
      ligatures: 'chevron_down',
    },
    {
      order: 2356,
      name: 'chevron_left',
      prevSize: 32,
      ligatures: 'chevron_left',
    },
    {
      order: 2357,
      name: 'chevron_right',
      prevSize: 32,
      ligatures: 'chevron_right',
    },
    {
      order: 2358,
      name: 'chevron_up',
      prevSize: 32,
      ligatures: 'chevron_up',
    },
    {
      order: 2359,
      name: 'carat_down',
      prevSize: 32,
      ligatures: 'carat_down',
    },
    {
      order: 2360,
      name: 'carat_left',
      prevSize: 32,
      ligatures: 'carat_left',
    },
    {
      order: 2361,
      name: 'carat_right',
      prevSize: 32,
      ligatures: 'carat_right',
    },
    {
      order: 2362,
      name: 'carat_up',
      prevSize: 32,
      ligatures: 'carat_up',
    },
    {
      order: 2363,
      name: 'playback',
      prevSize: 32,
      ligatures: 'playback',
    },
    {
      order: 2364,
      name: 'playback_active',
      prevSize: 32,
      ligatures: 'playback_active',
    },
    {
      order: 2365,
      name: 'playforward',
      prevSize: 32,
      ligatures: 'playforward',
    },
    {
      order: 2366,
      name: 'playforward_active',
      prevSize: 32,
      ligatures: 'playforward_active',
    },
    {
      order: 2367,
      name: 'auths',
      prevSize: 32,
      ligatures: 'auths',
    },
    {
      order: 2368,
      name: 'auths_active',
      prevSize: 32,
      ligatures: 'auths_active',
    },
    {
      order: 2369,
      name: 'csr',
      prevSize: 32,
      ligatures: 'csr',
    },
    {
      order: 2370,
      name: 'csr_active',
      prevSize: 32,
      ligatures: 'csr_active',
    },
    {
      order: 2371,
      name: 'id',
      prevSize: 32,
      ligatures: 'id',
    },
    {
      order: 2372,
      name: 'id_active',
      prevSize: 32,
      ligatures: 'id_active',
    },
    {
      order: 2373,
      name: 'plans',
      prevSize: 32,
      ligatures: 'plans, plan_documents',
    },
    {
      order: 2374,
      name: 'plans_active',
      prevSize: 32,
      ligatures: 'plans_active, plan_documents_active',
    },
    {
      order: 2375,
      name: 'profile',
      prevSize: 32,
      ligatures: 'profile',
    },
    {
      order: 2376,
      name: 'profile_active',
      prevSize: 32,
      ligatures: 'profile_active',
    },
    {
      order: 2377,
      name: 'patients',
      prevSize: 32,
      ligatures: 'patients',
    },
    {
      order: 2378,
      name: 'patients_active',
      prevSize: 32,
      ligatures: 'patients_active',
    },
    {
      order: 2379,
      name: 'person',
      prevSize: 32,
      ligatures: 'person',
    },
    {
      order: 2380,
      name: 'person_active',
      prevSize: 32,
      ligatures: 'person_active',
    },
    {
      order: 2381,
      name: 'benefits',
      prevSize: 32,
      ligatures: 'benefits',
    },
    {
      order: 2382,
      name: 'benefits_active',
      prevSize: 32,
      ligatures: 'benefits_active',
    },
    {
      order: 2383,
      name: 'phone',
      prevSize: 32,
      ligatures: 'phone',
    },
    {
      order: 2384,
      name: 'phone_active',
      prevSize: 32,
      ligatures: 'phone_active',
    },
    {
      order: 2385,
      name: 'camera',
      prevSize: 32,
      ligatures: 'camera',
    },
    {
      order: 2386,
      name: 'camera_active',
      prevSize: 32,
      ligatures: 'camera_active',
    },
    {
      order: 2387,
      name: 'video',
      prevSize: 32,
      ligatures: 'video',
    },
    {
      order: 2388,
      name: 'video_active',
      prevSize: 32,
      ligatures: 'video_active',
    },
    {
      order: 2389,
      name: 'video_off',
      prevSize: 32,
      ligatures: 'video_off',
    },
    {
      order: 2390,
      name: 'video_off_active',
      prevSize: 32,
      ligatures: 'video_off_active',
    },
    {
      order: 2391,
      name: 'doctors',
      prevSize: 32,
      ligatures: 'doctors',
    },
    {
      order: 2392,
      name: 'doctors_active',
      prevSize: 32,
      ligatures: 'doctors_active',
    },
    {
      order: 2393,
      name: 'cart',
      prevSize: 32,
      ligatures: 'cart',
    },
    {
      order: 2394,
      name: 'cart_active',
      prevSize: 32,
      ligatures: 'cart_active',
    },
    {
      order: 2395,
      name: 'chat',
      prevSize: 32,
      ligatures: 'chat',
    },
    {
      order: 2396,
      name: 'chat_active',
      prevSize: 32,
      ligatures: 'chat_active',
    },
    {
      order: 2397,
      name: 'costs',
      prevSize: 32,
      ligatures: 'costs',
    },
    {
      order: 2398,
      name: 'costs_active',
      prevSize: 32,
      ligatures: 'costs_active',
    },
    {
      order: 2399,
      name: 'faq',
      prevSize: 32,
      ligatures: 'faq',
    },
    {
      order: 2400,
      name: 'faq_active',
      prevSize: 32,
      ligatures: 'faq_active',
    },
    {
      order: 2401,
      name: 'feedback',
      prevSize: 32,
      ligatures: 'feedback',
    },
    {
      order: 2402,
      name: 'feedback_active',
      prevSize: 32,
      ligatures: 'feedback_active',
    },
    {
      order: 2403,
      name: 'hearing',
      prevSize: 32,
      ligatures: 'hearing',
    },
    {
      order: 2404,
      name: 'hierarchy',
      prevSize: 32,
    },
    {
      order: 2405,
      name: 'hierarchy_active',
      prevSize: 32,
      ligatures: 'hierarchy_active',
    },
    {
      order: 2406,
      name: 'home',
      prevSize: 32,
      ligatures: 'home',
    },
    {
      order: 2407,
      name: 'home_active',
      prevSize: 32,
      ligatures: 'home_active',
    },
    {
      order: 2408,
      name: 'location',
      prevSize: 32,
      ligatures: 'location',
    },
    {
      order: 2409,
      name: 'location_active',
      prevSize: 32,
      ligatures: 'location_active',
    },
    {
      order: 2410,
      name: 'coverage',
      prevSize: 32,
      ligatures: 'coverage',
    },
    {
      order: 2411,
      name: 'coverage_active',
      prevSize: 32,
      ligatures: 'coverage_active',
    },
    {
      order: 2412,
      name: 'order',
      prevSize: 32,
      ligatures: 'order',
    },
    {
      order: 2413,
      name: 'order_active',
      prevSize: 32,
      ligatures: 'order_active',
    },
    {
      order: 2414,
      name: 'medal',
      prevSize: 32,
      ligatures: 'medal',
    },
    {
      order: 2415,
      name: 'medal_active',
      prevSize: 32,
      ligatures: 'medal_active',
    },
    {
      order: 2416,
      name: 'email',
      prevSize: 32,
      ligatures: 'email',
    },
    {
      order: 2417,
      name: 'email_active',
      prevSize: 32,
      ligatures: 'email_active',
    },
    {
      order: 2418,
      name: 'notification',
      prevSize: 32,
      ligatures: 'notification',
    },
    {
      order: 2419,
      name: 'notification_active',
      prevSize: 32,
      ligatures: 'notification_active',
    },
    {
      order: 2420,
      name: 'payments',
      prevSize: 32,
      ligatures: 'payments',
    },
    {
      order: 2421,
      name: 'payments_active',
      prevSize: 32,
      ligatures: 'payments_active',
    },
    {
      order: 2422,
      name: 'pharmacy',
      prevSize: 32,
      ligatures: 'pharmacy',
    },
    {
      order: 2423,
      name: 'pharmacy_active',
      prevSize: 32,
      ligatures: 'pharmacy_active',
    },
    {
      order: 2424,
      name: 'prescription',
      prevSize: 32,
      ligatures: 'prescription',
    },
    {
      order: 2425,
      name: 'prescription_active',
      prevSize: 32,
      ligatures: 'prescription_active',
    },
    {
      order: 2426,
      name: 'settings',
      prevSize: 32,
      ligatures: 'settings',
    },
    {
      order: 2427,
      name: 'settings_active',
      prevSize: 32,
      ligatures: 'settings_active',
    },
    {
      order: 2428,
      name: 'support',
      prevSize: 32,
      ligatures: 'support',
    },
    {
      order: 2429,
      name: 'support_active',
      prevSize: 32,
      ligatures: 'support_active',
    },
    {
      order: 2430,
      name: 'taxi',
      prevSize: 32,
      ligatures: 'taxi',
    },
    {
      order: 2431,
      name: 'taxi_active',
      prevSize: 32,
      ligatures: 'taxi_active',
    },
    {
      order: 2432,
      name: 'telemedicine',
      prevSize: 32,
      ligatures: 'telemedicine',
    },
    {
      order: 2433,
      name: 'telemedicine_active',
      prevSize: 32,
      ligatures: 'telemedicine_active',
    },
    {
      order: 2434,
      name: 'library',
      prevSize: 32,
      ligatures: 'library',
    },
    {
      order: 2435,
      name: 'library_active',
      prevSize: 32,
      ligatures: 'library_active',
    },
    {
      order: 2436,
      name: 'wellness',
      prevSize: 32,
      ligatures: 'wellness',
    },
    {
      order: 2437,
      name: 'wellness_active',
      prevSize: 32,
      ligatures: 'wellness_active',
    },
    {
      order: 2438,
      name: 'work',
      prevSize: 32,
      ligatures: 'work',
    },
    {
      order: 2439,
      name: 'work_active',
      prevSize: 32,
      ligatures: 'work_active',
    },
    {
      order: 2440,
      name: 'claims',
      prevSize: 32,
      ligatures: 'claims',
    },
    {
      order: 2441,
      name: 'claims_active',
      prevSize: 32,
      ligatures: 'claims_active',
    },
    {
      order: 2442,
      name: 'documents',
      prevSize: 32,
      ligatures: 'documents',
    },
    {
      order: 2443,
      name: 'documents_active',
      prevSize: 32,
      ligatures: 'documents_active',
    },
    {
      order: 2444,
      name: 'hra',
      prevSize: 32,
      ligatures: 'hra',
    },
    {
      order: 2445,
      name: 'hra_active',
      prevSize: 32,
      ligatures: 'hra_active',
    },
    {
      order: 2446,
      name: 'healthwise',
      prevSize: 32,
      ligatures: 'healthwise',
    },
    {
      order: 2447,
      name: 'healthwise_active',
      prevSize: 32,
      ligatures: 'healthwise_active',
    },
    {
      order: 2448,
      name: 'pdf',
      prevSize: 32,
      ligatures: 'pdf',
    },
    {
      order: 2449,
      name: 'pdf_active',
      prevSize: 32,
      ligatures: 'pdf_active',
    },
    {
      order: 2450,
      name: 'send_to',
      prevSize: 32,
      ligatures: 'at, send_to',
    },
    {
      order: 2451,
      name: 'add',
      prevSize: 32,
      ligatures: 'add',
    },
    {
      order: 2452,
      name: 'archive',
      prevSize: 32,
      ligatures: 'archive',
    },
    {
      order: 2453,
      name: 'archive_active',
      prevSize: 32,
      ligatures: 'archive_active',
    },
    {
      order: 2454,
      name: 'attachment',
      prevSize: 32,
      ligatures: 'attachment',
    },
    {
      order: 2455,
      name: 'calendar',
      prevSize: 32,
      ligatures: 'calendar',
    },
    {
      order: 2456,
      name: 'calendar_active',
      prevSize: 32,
      ligatures: 'calendar_active',
    },
    {
      order: 2457,
      name: 'checkbox',
      prevSize: 32,
      ligatures: 'checkbox',
    },
    {
      order: 2458,
      name: 'checkbox_active',
      prevSize: 32,
      ligatures: 'checkbox_active',
    },
    {
      order: 2459,
      name: 'checkbox_all',
      prevSize: 32,
      ligatures: 'checkbox_all',
    },
    {
      order: 2460,
      name: 'close',
      prevSize: 32,
      ligatures: 'close',
    },
    {
      order: 2461,
      name: 'trash',
      prevSize: 32,
      ligatures: 'trash',
    },
    {
      order: 2462,
      name: 'delete_active',
      prevSize: 32,
      ligatures: 'delete_active',
    },
    {
      order: 2463,
      name: 'directions',
      prevSize: 32,
      ligatures: 'directions',
    },
    {
      order: 2464,
      name: 'directions_active',
      prevSize: 32,
      ligatures: 'directions_active',
    },
    {
      order: 2465,
      name: 'document_upload',
      prevSize: 32,
      ligatures: 'document_upload',
    },
    {
      order: 2466,
      name: 'document_upload_active',
      prevSize: 32,
      ligatures: 'document_upload_active',
    },
    {
      order: 2467,
      name: 'download',
      prevSize: 32,
      ligatures: 'download',
    },
    {
      order: 2468,
      name: 'download_active',
      prevSize: 32,
      ligatures: 'download_active',
    },
    {
      order: 2469,
      name: 'edit',
      prevSize: 32,
      ligatures: 'edit',
    },
    {
      order: 2470,
      name: 'edit_active',
      prevSize: 32,
      ligatures: 'edit_active',
    },
    {
      order: 2471,
      name: 'enlarge',
      prevSize: 32,
      ligatures: 'enlarge',
    },
    {
      order: 2472,
      name: 'eye',
      prevSize: 32,
      ligatures: 'eye',
    },
    {
      order: 2473,
      name: 'eye-hide',
      prevSize: 32,
      ligatures: 'eye_hide',
    },
    {
      order: 2474,
      name: 'eye_active',
      prevSize: 32,
      ligatures: 'eye_active',
    },
    {
      order: 2475,
      name: 'eye_active_hide',
      prevSize: 32,
      ligatures: 'eye_hide_active',
    },
    {
      order: 2476,
      name: 'exit',
      prevSize: 32,
      ligatures: 'exit',
    },
    {
      order: 2477,
      name: 'bookmark',
      prevSize: 32,
      ligatures: 'bookmark',
    },
    {
      order: 2478,
      name: 'bookmark_active',
      prevSize: 32,
      ligatures: 'bookmark_active',
    },
    {
      order: 2479,
      name: 'star',
      prevSize: 32,
      ligatures: 'star',
    },
    {
      order: 2480,
      name: 'star_active',
      prevSize: 32,
      ligatures: 'star_active',
    },
    {
      order: 2481,
      name: 'heart',
      prevSize: 32,
      ligatures: 'heart',
    },
    {
      order: 2482,
      name: 'heart_active',
      prevSize: 32,
      ligatures: 'heart_active',
    },
    {
      order: 2483,
      name: 'tune',
      prevSize: 32,
      ligatures: 'tune',
    },
    {
      order: 2484,
      name: 'flip',
      prevSize: 32,
      ligatures: 'flip, flip_back',
    },
    {
      order: 2485,
      name: 'flip_front',
      prevSize: 32,
      ligatures: 'flip_front',
    },
    {
      order: 2486,
      name: 'hamburger',
      prevSize: 32,
      ligatures: 'hamburger',
    },
    {
      order: 2487,
      name: 'help',
      prevSize: 32,
      ligatures: 'help',
    },
    {
      order: 2488,
      name: 'help_active',
      prevSize: 32,
      ligatures: 'help_active',
    },
    {
      order: 2489,
      name: 'line_of_business',
      prevSize: 32,
      ligatures: 'line_of_business',
    },
    {
      order: 2490,
      name: 'open_in_new',
      prevSize: 32,
      ligatures: 'open_in_new',
    },
    {
      order: 2491,
      name: 'loading',
      prevSize: 32,
      ligatures: 'loading',
    },
    {
      order: 2492,
      name: 'unlock',
      prevSize: 32,
      ligatures: 'unlock',
    },
    {
      order: 2493,
      name: 'lock',
      prevSize: 32,
      ligatures: 'lock',
    },
    {
      order: 2494,
      name: 'lock_active',
      prevSize: 32,
      ligatures: 'lock_active',
    },
    {
      order: 2495,
      name: 'more',
      prevSize: 32,
      ligatures: 'more',
    },
    {
      order: 2496,
      name: 'pause',
      prevSize: 32,
      ligatures: 'pause',
    },
    {
      order: 2497,
      name: 'pause_active',
      prevSize: 32,
      ligatures: 'pause_active',
    },
    {
      order: 2498,
      name: 'print',
      prevSize: 32,
      ligatures: 'print',
    },
    {
      order: 2499,
      name: 'print_active',
      prevSize: 32,
      ligatures: 'print_active',
    },
    {
      order: 2500,
      name: 'radio',
      prevSize: 32,
      ligatures: 'radio',
    },
    {
      order: 2501,
      name: 'radio_active',
      prevSize: 32,
      ligatures: 'radio_active',
    },
    {
      order: 2502,
      name: 'reply',
      prevSize: 32,
      ligatures: 'reply',
    },
    {
      order: 2503,
      name: 'search',
      prevSize: 32,
      ligatures: 'search',
    },
    {
      order: 2504,
      name: 'send',
      prevSize: 32,
      ligatures: 'send',
    },
    {
      order: 2505,
      name: 'share',
      prevSize: 32,
      ligatures: 'share',
    },
    {
      order: 2506,
      name: 'share_active',
      prevSize: 32,
      ligatures: 'share_active',
    },
    {
      order: 2507,
      name: 'spellcheck',
      prevSize: 32,
      ligatures: 'spellcheck',
    },
    {
      order: 2508,
      name: 'sort',
      prevSize: 32,
      ligatures: 'sort',
    },
    {
      order: 2509,
      name: 'subtract',
      prevSize: 32,
      ligatures: 'subtract',
    },
    {
      order: 2510,
      name: 'stepper',
      prevSize: 32,
      ligatures: 'stepper',
    },
    {
      order: 2511,
      name: 'table',
      prevSize: 32,
      ligatures: 'table',
    },
    {
      order: 2512,
      name: 'info',
      prevSize: 32,
      ligatures: 'info',
    },
    {
      order: 2513,
      name: 'info_active',
      prevSize: 32,
      ligatures: 'info_active',
    },
    {
      order: 2514,
      name: 'undo',
      prevSize: 32,
      ligatures: 'undo',
    },
    {
      order: 2515,
      name: 'unfold_less',
      prevSize: 32,
      ligatures: 'unfold_less',
    },
    {
      order: 2516,
      name: 'unfold_more',
      prevSize: 32,
      ligatures: 'unfold_more',
    },
    {
      order: 2517,
      name: 'upload',
      prevSize: 32,
      ligatures: 'upload',
    },
    {
      order: 2518,
      name: 'upload_active',
      prevSize: 32,
      ligatures: 'upload_active',
    },
    {
      order: 2519,
      name: 'cloud_upload',
      prevSize: 32,
      ligatures: 'cloud_upload',
    },
    {
      order: 2520,
      name: 'cloud_upload_active',
      prevSize: 32,
      ligatures: 'cloud_upload_active',
    },
    {
      order: 2521,
      name: 'thumb_down',
      prevSize: 32,
      ligatures: 'thumb_down',
    },
    {
      order: 2522,
      name: 'thumb_down_active',
      prevSize: 32,
      ligatures: 'thumb_down_active',
    },
    {
      order: 2523,
      name: 'thumb_up',
      prevSize: 32,
      ligatures: 'thumb_up',
    },
    {
      order: 2524,
      name: 'thumb_up_active',
      prevSize: 32,
      ligatures: 'thumb_up_active',
    },
    {
      order: 2525,
      name: 'check_circle',
      prevSize: 32,
      ligatures: 'check_circle',
    },
    {
      order: 2526,
      name: 'check_circle_active',
      prevSize: 32,
      ligatures: 'check_circle_active',
    },
    {
      order: 2527,
      name: 'check',
      prevSize: 32,
      ligatures: 'check',
    },
    {
      order: 2528,
      name: 'double_check',
      prevSize: 32,
      ligatures: 'double_check',
    },
    {
      order: 2529,
      name: 'error',
      prevSize: 32,
      ligatures: 'error',
    },
    {
      order: 2530,
      name: 'error_active',
      prevSize: 32,
      ligatures: 'error_active',
    },
    {
      order: 2531,
      name: 'flag',
      prevSize: 32,
      ligatures: 'flag',
    },
    {
      order: 2532,
      name: 'flag_active',
      prevSize: 32,
      ligatures: 'flag_active',
    },
    {
      order: 2533,
      name: 'bullet',
      prevSize: 32,
      ligatures: 'bullet',
    },
    {
      order: 2534,
      name: 'face',
      prevSize: 32,
      ligatures: 'face',
    },
    {
      order: 2535,
      name: 'warning',
      prevSize: 32,
      ligatures: 'warning',
    },
    {
      order: 2536,
      name: 'first_page',
      prevSize: 32,
      ligatures: 'first_page',
    },
    {
      order: 2537,
      name: 'last_page',
      prevSize: 32,
      ligatures: 'last_page',
    },
  ],
  metadata: {
    name: 'Zipari',
    importSize: {
      width: 24,
      height: 24,
    },
    iconsHash: 729169365,
  },
  height: 1024,
  prevSize: 24,
  icons: [
    {
      paths: [
        'M401.067 708.267l-196.267-196.267 196.267-196.267-59.733-59.733-256 256 256 256 59.733-59.733zM622.933 708.267l196.267-196.267-196.267-196.267 59.733-59.733 256 256-256 256-59.733-59.733z',
      ],
      grid: 0,
      tags: ['outline-code-24px'],
      defaultCode: 59833,
    },
    {
      paths: [
        'M0 256h256v-256h-256v256zM384 1024h256v-256h-256v256zM0 1024h256v-256h-256v256zM0 640h256v-256h-256v256zM384 640h256v-256h-256v256zM768 0v256h256v-256h-256zM384 256h256v-256h-256v256zM768 640h256v-256h-256v256zM768 1024h256v-256h-256v256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['grid'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59832,
    },
    {
      paths: [
        'M853.333 512l-60.16-60.16-238.507 238.080v-519.253h-85.333v519.253l-238.080-238.507-60.587 60.587 341.333 341.333z',
      ],
      grid: 0,
      tags: ['arrow_down'],
      defaultCode: 59692,
    },
    {
      paths: [
        'M853.333 469.333h-519.253l238.507-238.507-60.587-60.16-341.333 341.333 341.333 341.333 60.16-60.16-238.080-238.507h519.253z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['arrow_left'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59689,
    },
    {
      paths: [
        'M512 170.667l-60.16 60.16 238.080 238.507h-519.253v85.333h519.253l-238.080 238.507 60.16 60.16 341.333-341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['arrow_right'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59693,
    },
    {
      paths: [
        'M170.667 512l60.16 60.16 238.507-238.080v519.253h85.333v-519.253l238.080 238.507 60.587-60.587-341.333-341.333z',
      ],
      grid: 0,
      tags: ['arrow_up'],
      defaultCode: 59695,
    },
    {
      paths: [
        'M597.333 213.333v85.333h-281.173l494.507 494.507-60.16 60.16-494.507-494.507v281.173h-85.333v-426.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['arrow_diagonal_left'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59694,
    },
    {
      paths: [
        'M810.667 298.667v170.667h-561.92l152.747-153.173-60.16-60.16-256 256 256 256 60.16-60.16-152.747-153.173h647.253v-256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['arrow_return'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59728,
    },
    {
      paths: [
        'M316.16 377.173l195.84 195.413 195.84-195.413 60.16 60.16-256 256-256-256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['chevron_down'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59703,
    },
    {
      paths: [
        'M657.493 316.16l-60.16-60.16-256 256 256 256 60.16-60.16-195.413-195.84z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['chevron_left'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59704,
    },
    {
      paths: [
        'M426.667 256l-60.16 60.16 195.413 195.84-195.413 195.84 60.16 60.16 256-256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['chevron_right'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59705,
    },
    {
      paths: [
        'M707.84 693.333l-195.84-195.413-195.84 195.413-60.16-60.16 256-256 256 256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['chevron_up'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59706,
    },
    {
      paths: ['M298.667 426.667l213.333 213.333 213.333-213.333z'],
      grid: 0,
      tags: ['carat_down'],
      defaultCode: 59699,
    },
    {
      paths: ['M597.333 298.667l-213.333 213.333 213.333 213.333v-426.667z'],
      grid: 0,
      tags: ['baseline-arrow_left-24px'],
      defaultCode: 59770,
    },
    {
      paths: ['M426.667 725.333l213.333-213.333-213.333-213.333v426.667z'],
      grid: 0,
      tags: ['baseline-arrow_right-24px'],
      defaultCode: 59771,
    },
    {
      paths: ['M298.667 640l213.333-213.333 213.333 213.333z'],
      grid: 0,
      tags: ['carat_up'],
      defaultCode: 59700,
    },
    {
      paths: [
        'M256 256h85.333v512h-85.333v-512zM405.333 512l362.667 256v-512l-362.667 256zM682.667 603.307l-129.28-91.307 129.28-91.307v182.613z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['playback'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59747,
    },
    {
      paths: [
        'M256 256h85.333v512h-85.333v-512zM405.333 512l362.667 256v-512l-362.667 256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['playback_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59764,
    },
    {
      paths: [
        'M256 768l362.667-256-362.667-256v512zM341.333 420.693l129.28 91.307-129.28 91.307v-182.613zM682.667 256h85.333v512h-85.333v-512z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['playforward'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59765,
    },
    {
      paths: [
        'M256 768l362.667-256-362.667-256v512zM682.667 256v512h85.333v-512h-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['playforward_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59776,
    },
    {
      paths: [
        'M469.333 512c94.293 0 170.667-76.373 170.667-170.667s-76.373-170.667-170.667-170.667c-94.293 0-170.667 76.373-170.667 170.667s76.373 170.667 170.667 170.667zM469.333 256c46.933 0 85.333 38.4 85.333 85.333s-38.4 85.333-85.333 85.333c-46.933 0-85.333-38.4-85.333-85.333s38.4-85.333 85.333-85.333zM213.333 768c8.533-26.88 109.653-71.68 211.627-82.773l87.040-85.333c-16.64-1.707-29.013-2.56-42.667-2.56-113.92 0-341.333 57.173-341.333 170.667v85.333h384l-85.333-85.333h-213.333zM878.933 533.333l-218.88 220.587-88.32-88.747-59.733 60.16 148.053 149.333 278.613-281.173-59.733-60.16z',
      ],
      grid: 0,
      tags: ['auths'],
      defaultCode: 59697,
    },
    {
      paths: [
        'M384 725.333l128-125.44c-16.64-1.707-29.013-2.56-42.667-2.56-113.92 0-341.333 57.173-341.333 170.667v85.333h384l-128-128zM469.333 512c-94.293 0-170.667-76.373-170.667-170.667s76.373-170.667 170.667-170.667c94.293 0 170.667 76.373 170.667 170.667s-76.373 170.667-170.667 170.667zM660.053 874.667l-148.053-149.333 59.733-60.16 88.32 88.747 218.88-220.587 59.733 60.16-278.613 281.173z',
      ],
      grid: 0,
      tags: ['auths_active'],
      defaultCode: 59696,
    },
    {
      paths: [
        'M725.333 128c-47.128 0-85.333 38.205-85.333 85.333v0 298.667l85.333-85.333h170.667c47.128 0 85.333-38.205 85.333-85.333v0-128c0-47.128-38.205-85.333-85.333-85.333v0h-170.667zM405.333 213.333c-82.329 0.362-148.971 67.005-149.333 149.299l-0 0.035c0 81.963 67.371 149.333 149.333 149.333s149.333-67.371 149.333-149.333-67.371-149.333-149.333-149.333zM725.333 213.333h170.667v128h-170.667v-128zM405.333 298.667c35.84 0 64 28.16 64 64s-28.16 64-64 64-64-28.16-64-64 28.16-64 64-64zM405.333 597.333c-63.445 0-136.448 18.005-198.4 48.085-30.976 15.061-59.136 33.067-81.493 55.979-22.4 22.955-40.107 52.864-40.107 87.936v106.667h640v-106.667c0-35.072-17.707-64.981-40.107-87.893-22.357-22.955-50.517-40.96-81.493-56.021-61.952-30.080-134.955-48.085-198.4-48.085zM405.333 682.667c46.080 0 111.787 15.531 161.067 39.509 24.704 11.947 45.269 26.027 57.771 38.827s15.829 22.187 15.829 28.331v21.333h-469.333v-21.333c0-6.144 3.328-15.531 15.829-28.331s33.067-26.88 57.771-38.827c49.28-23.979 114.987-39.509 161.067-39.509z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['csr'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59777,
    },
    {
      paths: [
        'M725.333 128c-47.128 0-85.333 38.205-85.333 85.333v0 298.667l85.333-85.333h170.667c17.664 0 34.048-5.376 47.659-14.592 22.848-15.408 37.675-41.194 37.675-70.443 0-0.105-0-0.21-0.001-0.314l0 0.016v-128c0-17.664-5.376-34.048-14.592-47.659-6.239-9.157-13.898-16.829-22.746-22.892l-0.294-0.19c-13.318-9.137-29.785-14.592-47.527-14.592-0.061 0-0.123 0-0.184 0l0.010-0h-170.667zM405.333 213.333c-82.475 0-149.333 66.859-149.333 149.333s66.859 149.333 149.333 149.333v0c82.475 0 149.333-66.859 149.333-149.333s-66.859-149.333-149.333-149.333v0zM405.333 597.333c-127.36 0-320 76.587-320 192v106.667h640v-106.667c0-115.413-192.64-192-320-192z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['csr_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59778,
    },
    {
      paths: [
        'M938.667 128h-853.333c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h853.333c46.933 0 84.907-38.4 84.907-85.333l0.427-597.333c0-46.933-38.4-85.333-85.333-85.333zM938.667 810.667h-853.333v-597.333h853.333v597.333zM384 512c70.4 0 128-57.6 128-128s-57.6-128-128-128c-70.4 0-128 57.6-128 128s57.6 128 128 128zM384 341.333c23.467 0 42.667 19.2 42.667 42.667s-19.2 42.667-42.667 42.667c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667zM640 707.84c0-106.667-169.387-152.747-256-152.747s-256 46.080-256 152.747v60.16h512v-60.16zM233.813 682.667c31.573-21.333 94.72-42.667 150.187-42.667s118.187 20.907 150.187 42.667h-300.373z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['id'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59675,
    },
    {
      paths: [
        'M938.667 128h-853.333c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h853.333c46.933 0 84.907-38.4 84.907-85.333l0.427-597.333c0-46.933-38.4-85.333-85.333-85.333zM341.333 256c70.827 0 128 57.173 128 128s-57.173 128-128 128c-70.827 0-128-57.173-128-128s57.173-128 128-128zM597.333 768h-512v-42.667c0-85.333 170.667-132.267 256-132.267s256 46.933 256 132.267v42.667z',
      ],
      grid: 0,
      tags: ['id_active'],
      defaultCode: 59725,
    },
    {
      paths: [
        'M853.333 256h-341.333l-85.333-85.333h-256c-46.933 0-84.907 38.4-84.907 85.333l-0.427 512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM853.333 768h-682.667v-512h220.587l85.333 85.333h376.747v426.667zM640 554.667c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333zM469.333 725.333h341.333v-42.667c0-56.747-113.92-85.333-170.667-85.333s-170.667 28.587-170.667 85.333v42.667z',
      ],
      grid: 0,
      tags: ['plans'],
      defaultCode: 59737,
    },
    {
      paths: [
        'M853.333 256h-341.333l-85.333-85.333h-256c-46.933 0-84.907 38.4-84.907 85.333l-0.427 512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM640 384c46.933 0 85.333 38.4 85.333 85.333s-38.4 85.333-85.333 85.333c-46.933 0-85.333-38.4-85.333-85.333s38.4-85.333 85.333-85.333zM810.667 725.333h-341.333v-42.667c0-56.747 113.92-85.333 170.667-85.333s170.667 28.587 170.667 85.333v42.667z',
      ],
      grid: 0,
      tags: ['plans_active'],
      defaultCode: 59736,
    },
    {
      paths: [
        'M499.908 85.333c-228.845 0-414.575 185.73-414.575 414.575s185.73 414.575 414.575 414.575c228.845 0 414.575-185.73 414.575-414.575s-185.73-414.575-414.575-414.575zM295.523 760.261c17.827-37.312 126.445-73.794 204.385-73.794s186.973 36.483 204.385 73.794c-56.382 44.774-127.274 71.307-204.385 71.307s-148.003-26.533-204.385-71.307zM763.578 700.148c-59.284-72.136-203.142-96.596-263.67-96.596s-204.385 24.46-263.67 96.596c-42.287-55.553-67.99-124.787-67.99-200.24 0-182.828 148.832-331.66 331.66-331.66s331.66 148.832 331.66 331.66c0 75.453-25.704 144.687-67.99 200.24zM499.908 251.163c-80.428 0-145.101 64.674-145.101 145.101s64.674 145.101 145.101 145.101c80.428 0 145.101-64.674 145.101-145.101s-64.674-145.101-145.101-145.101zM499.908 458.451c-34.41 0-62.186-27.777-62.186-62.186s27.777-62.186 62.186-62.186c34.41 0 62.186 27.777 62.186 62.186s-27.777 62.186-62.186 62.186z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['profile'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59682,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 213.333c70.827 0 128 57.173 128 128s-57.173 128-128 128c-70.827 0-128-57.173-128-128s57.173-128 128-128zM512 819.2c-106.667 0-200.96-54.613-256-137.387 1.28-84.907 170.667-131.413 256-131.413 84.907 0 254.72 46.507 256 131.413-55.040 82.773-149.333 137.387-256 137.387z',
      ],
      grid: 0,
      tags: ['profile_active'],
      defaultCode: 59738,
    },
    {
      paths: [
        'M384 586.667c-99.84 0-298.667 49.92-298.667 149.333v74.667h597.333v-74.667c0-99.413-198.827-149.333-298.667-149.333zM185.173 725.333c35.84-24.747 122.453-53.333 198.827-53.333s162.987 28.587 198.827 53.333h-397.653zM384 512c82.347 0 149.333-66.987 149.333-149.333s-66.987-149.333-149.333-149.333c-82.347 0-149.333 66.987-149.333 149.333s66.987 149.333 149.333 149.333zM384 298.667c35.413 0 64 28.587 64 64s-28.587 64-64 64c-35.413 0-64-28.587-64-64s28.587-64 64-64zM684.373 589.227c49.493 35.84 83.627 83.627 83.627 146.773v74.667h170.667v-74.667c0-86.187-149.333-135.253-254.293-146.773zM640 512c82.347 0 149.333-66.987 149.333-149.333s-66.987-149.333-149.333-149.333c-23.040 0-44.373 5.547-64 14.933 26.88 37.973 42.667 84.48 42.667 134.4s-15.787 96.427-42.667 134.4c19.627 9.387 40.96 14.933 64 14.933z',
      ],
      grid: 0,
      tags: ['patients'],
      defaultCode: 59752,
    },
    {
      paths: [
        'M682.667 469.333c70.827 0 127.573-57.173 127.573-128s-56.747-128-127.573-128c-70.827 0-128 57.173-128 128s57.173 128 128 128zM341.333 469.333c70.827 0 127.573-57.173 127.573-128s-56.747-128-127.573-128c-70.827 0-128 57.173-128 128s57.173 128 128 128zM341.333 554.667c-99.413 0-298.667 49.92-298.667 149.333v106.667h597.333v-106.667c0-99.413-199.253-149.333-298.667-149.333zM682.667 554.667c-12.373 0-26.453 0.853-41.387 2.133 49.493 35.84 84.053 84.053 84.053 147.2v106.667h256v-106.667c0-99.413-199.253-149.333-298.667-149.333z',
      ],
      grid: 0,
      tags: ['patients_active'],
      defaultCode: 59751,
    },
    {
      paths: [
        'M512 251.733c49.493 0 89.6 40.107 89.6 89.6s-40.107 89.6-89.6 89.6-89.6-40.107-89.6-89.6 40.107-89.6 89.6-89.6zM512 635.733c126.72 0 260.267 62.293 260.267 89.6v46.933h-520.533v-46.933c0-27.307 133.547-89.6 260.267-89.6zM512 170.667c-94.293 0-170.667 76.373-170.667 170.667s76.373 170.667 170.667 170.667 170.667-76.373 170.667-170.667-76.373-170.667-170.667-170.667zM512 554.667c-113.92 0-341.333 57.173-341.333 170.667v128h682.667v-128c0-113.493-227.413-170.667-341.333-170.667z',
      ],
      grid: 0,
      tags: ['baseline-person_outline-24px'],
      defaultCode: 59768,
    },
    {
      paths: [
        'M512 512c94.293 0 170.667-76.373 170.667-170.667s-76.373-170.667-170.667-170.667-170.667 76.373-170.667 170.667 76.373 170.667 170.667 170.667zM512 597.333c-113.92 0-341.333 57.173-341.333 170.667v85.333h682.667v-85.333c0-113.493-227.413-170.667-341.333-170.667z',
      ],
      grid: 0,
      tags: ['baseline-person-24px'],
      defaultCode: 59769,
    },
    {
      paths: [
        'M512 234.667c-141.227 0-256 114.773-256 256s114.773 256 256 256c141.227 0 256-114.773 256-256s-114.773-256-256-256zM512 661.333c-94.293 0-170.667-76.373-170.667-170.667s76.373-170.667 170.667-170.667c94.293 0 170.667 76.373 170.667 170.667s-76.373 170.667-170.667 170.667zM151.467 791.040l76.373-76.8 60.16 60.16-76.373 76.8-60.16-60.16zM469.333 832h85.333v125.867h-85.333v-125.867zM853.333 448h128v85.333h-128v-85.333zM735.573 774.827l59.733-59.733 76.8 76.373-60.16 60.16-76.373-76.8zM820.324 130.133l60.038 60.038-76.329 76.329-60.038-60.038 76.329-76.329zM469.333 23.467h85.333v125.867h-85.333v-125.867zM42.667 448h128v85.333h-128v-85.333zM288.427 206.507l-60.587 60.16-76.373-76.373 60.16-60.16 76.8 76.373z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['benefits'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59650,
    },
    {
      paths: [
        'M288.427 206.507l-76.8-76.373-60.16 60.16 76.373 76.373 60.587-60.16zM170.667 448h-128v85.333h128v-85.333zM554.667 23.467h-85.333v125.867h85.333v-125.867zM872.533 190.293l-60.16-60.16-76.373 76.373 60.16 60.16 76.373-76.373zM735.573 774.827l76.373 76.8 60.16-60.16-76.8-76.373-59.733 59.733zM853.333 448v85.333h128v-85.333h-128zM512 234.667c-141.227 0-256 114.773-256 256s114.773 256 256 256c141.227 0 256-114.773 256-256s-114.773-256-256-256zM469.333 957.867h85.333v-125.867h-85.333v125.867zM151.467 791.040l60.16 60.16 76.373-76.8-60.16-60.16-76.373 76.8z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['benefits_active'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59698,
    },
    {
      paths: [
        'M279.040 213.333c2.56 37.973 8.96 75.093 19.2 110.507l-51.2 51.2c-17.493-51.2-28.587-105.387-32.427-161.707h64.427zM699.733 726.187c36.267 10.24 73.387 16.64 110.933 19.2v63.573c-56.32-3.84-110.507-14.933-162.133-32l51.2-50.773zM320 128h-149.333c-23.467 0-42.667 19.2-42.667 42.667 0 400.64 324.693 725.333 725.333 725.333 23.467 0 42.667-19.2 42.667-42.667v-148.907c0-23.467-19.2-42.667-42.667-42.667-52.907 0-104.533-8.533-152.32-24.32-4.267-1.707-8.96-2.133-13.227-2.133-11.093 0-21.76 4.267-30.293 12.373l-93.867 93.867c-120.747-61.867-219.733-160.427-281.173-281.173l93.867-93.867c11.947-11.947 15.36-28.587 10.667-43.52-15.787-47.787-24.32-98.987-24.32-152.32 0-23.467-19.2-42.667-42.667-42.667z',
      ],
      grid: 0,
      tags: ['phone'],
      defaultCode: 59681,
    },
    {
      paths: [
        'M282.453 460.373c61.44 120.747 160.427 219.307 281.173 281.173l93.867-93.867c11.52-11.52 28.587-15.36 43.52-10.24 47.787 15.787 99.413 24.32 152.32 24.32 23.467 0 42.667 19.2 42.667 42.667v148.907c0 23.467-19.2 42.667-42.667 42.667-400.64 0-725.333-324.693-725.333-725.333 0-23.467 19.2-42.667 42.667-42.667h149.333c23.467 0 42.667 19.2 42.667 42.667 0 53.333 8.533 104.533 24.32 152.32 4.693 14.933 1.28 31.573-10.667 43.52l-93.867 93.867z',
      ],
      grid: 0,
      tags: ['phone_active'],
      defaultCode: 59735,
    },
    {
      paths: [
        'M853.333 170.667h-135.253l-78.080-85.333h-256l-78.080 85.333h-135.253c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM853.333 768h-682.667v-512h172.8l78.080-85.333h180.907l78.080 85.333h172.8v512zM512 298.667c-117.76 0-213.333 95.573-213.333 213.333s95.573 213.333 213.333 213.333 213.333-95.573 213.333-213.333-95.573-213.333-213.333-213.333zM512 640c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128-57.6 128-128 128z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['camera'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59779,
    },
    {
      paths: [
        'M648.533 554.667c0 75.405-61.128 136.533-136.533 136.533s-136.533-61.128-136.533-136.533c0-75.405 61.128-136.533 136.533-136.533s136.533 61.128 136.533 136.533z',
        'M384 128l-78.080 85.333h-135.253c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333h-135.253l-78.080-85.333h-256zM512 768c-117.76 0-213.333-95.573-213.333-213.333s95.573-213.333 213.333-213.333 213.333 95.573 213.333 213.333-95.573 213.333-213.333 213.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['camera_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59780,
    },
    {
      paths: [
        'M640 341.333v341.333h-426.667v-341.333h426.667zM682.667 256h-512c-23.467 0-42.667 19.2-42.667 42.667v426.667c0 23.467 19.2 42.667 42.667 42.667h512c23.467 0 42.667-19.2 42.667-42.667v-149.333l170.667 170.667v-469.333l-170.667 170.667v-149.333c0-23.467-19.2-42.667-42.667-42.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['video'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59781,
    },
    {
      paths: [
        'M725.333 448v-149.333c0-23.467-19.2-42.667-42.667-42.667h-512c-23.467 0-42.667 19.2-42.667 42.667v426.667c0 23.467 19.2 42.667 42.667 42.667h512c23.467 0 42.667-19.2 42.667-42.667v-149.333l170.667 170.667v-469.333l-170.667 170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['video_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59782,
    },
    {
      paths: [
        'M407.893 341.333l-85.333-85.333-177.067-176.64-60.16 60.16 116.48 116.48h-31.147c-23.467 0-42.667 19.2-42.667 42.667v426.667c0 23.467 19.2 42.667 42.667 42.667h512c8.96 0 16.64-3.413 23.467-7.68l135.68 135.68 60.16-60.16-494.080-494.507zM213.333 682.667v-341.333h73.813l341.333 341.333h-415.147zM640 341.333v111.36l256 256v-431.36l-170.667 170.667v-149.333c0-23.467-19.2-42.667-42.667-42.667h-239.36l85.333 85.333h111.36z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['video_off'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59783,
    },
    {
      paths: [
        'M896 277.333l-170.667 170.667v-149.333c0-23.467-19.2-42.667-42.667-42.667h-263.68l477.013 477.013v-455.68zM139.52 85.333l-54.187 54.187 116.48 116.48h-31.147c-23.467 0-42.667 19.2-42.667 42.667v426.667c0 23.467 19.2 42.667 42.667 42.667h512c8.96 0 16.64-3.413 23.040-7.68l136.107 135.68 54.187-54.187-756.48-756.48z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['video_off_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59784,
    },
    {
      paths: [
        'M810.667 128h-597.333c-46.933 0-84.907 38.4-84.907 85.333l-0.427 597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM810.667 810.667h-597.333v-597.333h597.333v597.333zM448 725.333h128v-149.333h149.333v-128h-149.333v-149.333h-128v149.333h-149.333v128h149.333v149.333z',
      ],
      grid: 0,
      tags: ['doctors'],
      defaultCode: 59659,
    },
    {
      paths: [
        'M810.667 128h-597.333c-46.933 0-84.907 38.4-84.907 85.333l-0.427 597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM768 597.333h-170.667v170.667h-170.667v-170.667h-170.667v-170.667h170.667v-170.667h170.667v170.667h170.667v170.667z',
      ],
      grid: 0,
      tags: ['doctors_active'],
      defaultCode: 59711,
    },
    {
      paths: [
        'M705.92 554.667c32 0 60.16-17.493 74.624-43.947l152.704-276.907c3.369-5.951 5.355-13.069 5.355-20.651 0-23.462-19.014-42.484-42.474-42.496l-631.254-0-40.107-85.333h-139.435v85.333h85.333l153.515 323.84-57.6 104.107c-31.147 57.173 9.813 126.72 74.667 126.72h511.787v-85.333h-511.787l46.933-85.333h317.739zM305.408 256h518.229l-117.76 213.333h-299.349l-101.12-213.333zM341.248 768c-46.933 0-84.907 38.4-84.907 85.333s37.973 85.333 84.907 85.333 85.291-38.4 85.291-85.333-38.4-85.333-85.333-85.333zM767.744 768c-46.933 0-84.907 38.4-84.907 85.333s37.973 85.333 84.907 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['cart'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59785,
    },
    {
      paths: [
        'M341.333 768c-46.933 0-84.907 38.4-84.907 85.333s37.973 85.333 84.907 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333zM85.333 85.333v85.333h85.333l153.6 323.84-57.6 104.533c-6.827 11.947-10.667 26.027-10.667 40.96 0 46.933 38.4 85.333 85.333 85.333h512v-85.333h-494.080c-5.973 0-10.667-4.693-10.667-10.667l1.28-5.12 38.4-69.547h317.867c32 0 60.16-17.493 74.667-43.947l152.747-276.907c3.242-5.883 5.149-12.895 5.149-20.352 0-23.6-19.104-42.738-42.691-42.795l-0.005-0h-631.040l-40.107-85.333h-139.52zM768 768c-46.933 0-84.907 38.4-84.907 85.333s37.973 85.333 84.907 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['cart_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59786,
    },
    {
      paths: [
        'M170.667 170.667h682.667v512h-632.747l-49.92 49.92v-561.92zM170.667 85.333c-46.933 0-84.907 38.4-84.907 85.333l-0.427 768 170.667-170.667h597.333c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333h-682.667zM256 512h341.333v85.333h-341.333v-85.333zM256 384h512v85.333h-512v-85.333zM256 256h512v85.333h-512v-85.333z',
      ],
      grid: 0,
      tags: ['chat'],
      defaultCode: 59653,
    },
    {
      paths: [
        'M853.333 85.333h-682.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 768 170.667-170.667h597.333c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM256 384h512v85.333h-512v-85.333zM597.333 597.333h-341.333v-85.333h341.333v85.333zM768 341.333h-512v-85.333h512v85.333z',
      ],
      grid: 0,
      tags: ['chat_active'],
      defaultCode: 59701,
    },
    {
      paths: [
        'M525.227 475.307c-75.52-19.2-99.84-40.107-99.84-71.253 0-35.84 33.707-61.013 89.6-61.013 58.88 0 81.067 28.16 82.773 69.973h72.96c-2.133-57.173-37.12-109.653-106.24-126.72v-72.96h-99.413v72.107c-64.427 13.653-116.053 55.467-116.053 119.893 0 76.373 63.573 114.773 156.16 136.96 83.2 19.627 99.84 49.067 99.84 79.787 0 22.613-16.64 59.307-89.6 59.307-68.267 0-95.147-30.72-98.987-69.973h-73.387c4.267 72.533 58.027 113.493 122.027 126.72v72.533h99.84v-71.253c64.853-12.373 116.053-49.493 116.48-118.187-0.427-93.867-81.067-126.293-156.16-145.92zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.16 0-341.333-153.173-341.333-341.333s153.173-341.333 341.333-341.333c188.16 0 341.333 153.173 341.333 341.333s-153.173 341.333-341.333 341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['costs'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59658,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM572.16 771.84v81.493h-113.92v-82.347c-72.96-15.36-134.827-62.293-139.52-145.067h83.627c4.267 44.8 34.987 79.787 113.067 79.787 83.627 0 102.4-41.813 102.4-67.84 0-35.413-18.773-68.693-113.92-91.307-105.813-25.6-178.347-69.12-178.347-156.587 0-73.387 59.307-121.173 132.693-136.96v-82.347h113.92v83.2c79.36 19.2 119.040 79.36 121.6 144.64h-83.627c-2.133-47.36-27.307-79.787-94.72-79.787-64 0-102.4 29.013-102.4 69.973 0 35.84 27.733 59.307 113.92 81.493s178.347 59.307 178.347 166.827c-0.427 78.080-58.88 120.747-133.12 134.827z',
      ],
      grid: 0,
      tags: ['costs_active'],
      defaultCode: 59708,
    },
    {
      paths: [
        'M810.667 85.333h-597.333c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h170.667l128 128 128-128h170.667c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM810.667 768h-206.080l-92.587 92.587-92.587-92.587h-206.080v-597.333h597.333v597.333zM469.333 640h85.333v85.333h-85.333v-85.333zM512 298.667c46.933 0 85.333 38.4 85.333 85.333 0 85.333-128 74.667-128 213.333h85.333c0-96 128-106.667 128-213.333 0-94.293-76.373-170.667-170.667-170.667s-170.667 76.373-170.667 170.667h85.333c0-46.933 38.4-85.333 85.333-85.333z',
      ],
      grid: 0,
      tags: ['faq'],
      defaultCode: 59670,
    },
    {
      paths: [
        'M810.667 85.333h-597.333c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h170.667l128 128 128-128h170.667c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM554.667 768h-85.333v-85.333h85.333v85.333zM642.987 437.333l-38.4 39.253c-30.72 31.147-49.92 56.747-49.92 120.747h-85.333v-21.333c0-46.933 19.2-89.6 49.92-120.747l52.907-53.76c15.787-15.36 25.173-36.693 25.173-60.16 0-46.933-38.4-85.333-85.333-85.333s-85.333 38.4-85.333 85.333h-85.333c0-94.293 76.373-170.667 170.667-170.667s170.667 76.373 170.667 170.667c0 37.547-15.36 71.68-39.68 96z',
      ],
      grid: 0,
      tags: ['faq_active'],
      defaultCode: 59717,
    },
    {
      paths: [
        'M853.333 170.667h-682.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 768 170.667-170.667h597.333c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM853.333 768h-632.747l-49.92 49.92v-561.92h682.667v512zM469.333 597.333h85.333v85.333h-85.333v-85.333zM469.333 341.333h85.333v170.667h-85.333v-170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['feedback'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59787,
    },
    {
      paths: [
        'M853.333 170.667h-682.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 768 170.667-170.667h597.333c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM554.667 682.667h-85.333v-85.333h85.333v85.333zM554.667 512h-85.333v-170.667h85.333v170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['feedback_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59788,
    },
    {
      paths: [
        'M725.333 853.333c-12.373 0-23.893-2.56-32.427-6.4-30.293-15.787-51.627-37.547-72.96-101.547-21.76-66.56-62.72-97.707-101.973-128-33.707-26.027-68.693-52.907-98.987-107.947-22.613-40.96-34.987-85.76-34.987-125.44 0-119.467 93.867-213.333 213.333-213.333s213.333 93.867 213.333 213.333h85.333c0-167.68-130.987-298.667-298.667-298.667s-298.667 130.987-298.667 298.667c0 53.76 16.213 113.067 45.653 166.4 38.827 70.4 84.48 105.813 121.6 134.4 34.56 26.453 59.307 45.653 72.96 87.467 25.6 77.653 58.453 121.173 116.48 151.467 20.576 9.492 44.65 15.027 70.016 15.027 94.233 0 170.624-76.391 170.624-170.624 0-0.048-0-0.096-0-0.144l0 0.007h-85.333c0 46.933-38.4 85.333-85.333 85.333zM325.973 112.64l-60.587-60.587c-84.877 84.698-137.387 201.803-137.387 331.173 0 0.272 0 0.544 0.001 0.816l-0-0.042c0 129.707 52.48 247.040 137.387 331.947l60.16-60.16c-69.339-69.536-112.213-165.494-112.213-271.465 0-0.113 0-0.226 0-0.339l-0 0.018c0-106.24 43.093-202.24 112.64-271.36zM490.667 384c0 58.91 47.756 106.667 106.667 106.667s106.667-47.756 106.667-106.667v0c0-58.91-47.756-106.667-106.667-106.667s-106.667 47.756-106.667 106.667v0z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['hearing'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59789,
    },
    {
      paths: [
        'M512 491.691v111.744l128 79.232 42.667-85.333zM512 491.691v111.744l-128 79.232-42.667-85.333z',
        'M469.333 384h85.333v213.333h-85.333z',
        'M682.667 640h256v256h-256zM85.333 640h256v256h-256z',
        'M640 256c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'none',
          stroke: 'rgb(12, 34, 80)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(12, 34, 80)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
      ],
      isMulticolor2: true,
      grid: 0,
      tags: ['hierarchy'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
          {
            s: 0,
          },
          {
            s: 0,
          },
        ],
      },
      defaultCode: 59790,
    },
    {
      paths: [
        'M682.667 256c0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-94.257 76.41-170.667 170.667-170.667s170.667 76.41 170.667 170.667z',
        'M469.333 384h85.333v213.333h-85.333z',
        'M512 491.691v111.744l-128 79.232-42.667-85.333zM512 491.691v111.744l128 79.232 42.667-85.333z',
        'M42.667 597.333h341.333v341.333h-341.333zM640 597.333h341.333v341.333h-341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['hierarchy_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59791,
    },
    {
      paths: [
        'M512 285.44l213.333 192v333.227h-85.333v-256h-256v256h-85.333v-333.227l213.333-192zM512 170.667l-426.667 384h128v341.333h256v-256h85.333v256h256v-341.333h128l-426.667-384z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['home'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59674,
    },
    {
      paths: [
        'M426.667 853.333v-256h170.667v256h213.333v-341.333h128l-426.667-384-426.667 384h128v341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['home_active'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59722,
    },
    {
      paths: [
        'M512 490.667c58.91 0 106.667-47.756 106.667-106.667s-47.756-106.667-106.667-106.667c-58.91 0-106.667 47.756-106.667 106.667s47.756 106.667 106.667 106.667zM512 85.333c-165.12 0-298.667 133.547-298.667 298.667 0 224 298.667 554.667 298.667 554.667s298.667-330.667 298.667-554.667c0-165.12-133.547-298.667-298.667-298.667zM298.667 384c0-117.76 95.573-213.333 213.333-213.333s213.333 95.573 213.333 213.333c0 122.88-122.88 306.773-213.333 421.547-88.747-113.92-213.333-299.947-213.333-421.547z',
      ],
      grid: 0,
      tags: ['location'],
      defaultCode: 59677,
    },
    {
      paths: [
        'M512 85.333c-165.12 0-298.667 133.547-298.667 298.667 0 224 298.667 554.667 298.667 554.667s298.667-330.667 298.667-554.667c0-165.12-133.547-298.667-298.667-298.667zM512 490.667c-58.88 0-106.667-47.787-106.667-106.667s47.787-106.667 106.667-106.667c58.88 0 106.667 47.787 106.667 106.667s-47.787 106.667-106.667 106.667z',
      ],
      grid: 0,
      tags: ['location_active'],
      defaultCode: 59727,
    },
    {
      paths: [
        'M913.493 494.080l-384-384c-15.36-15.36-36.693-24.747-60.16-24.747h-298.667c-46.933 0-85.333 38.4-85.333 85.333v298.667c0 23.467 9.387 44.8 25.173 60.587l384 384c15.36 15.36 36.693 24.747 60.16 24.747s44.8-9.387 60.16-25.173l298.667-298.667c15.787-15.36 25.173-36.693 25.173-60.16s-9.813-45.227-25.173-60.587zM554.667 853.76l-384-384.427v-298.667h298.667v-0.427l384 384-298.667 299.52zM379.733 535.467c0 24.32 9.813 45.653 25.6 61.867l149.333 149.333 149.333-149.333c15.787-15.787 25.6-37.973 25.6-61.867 0-48.213-39.253-87.467-87.467-87.467-24.32 0-46.080 9.813-61.867 25.6l-25.6 25.6-25.6-25.173c-15.787-16.213-37.973-26.027-61.867-26.027-48.213 0-87.467 39.253-87.467 87.467zM277.333 341.333c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64z',
      ],
      grid: 0,
      tags: ['coverage'],
      defaultCode: 59710,
    },
    {
      paths: [
        'M913.493 494.080l-384-384c-15.36-15.36-36.693-24.747-60.16-24.747h-298.667c-46.933 0-85.333 38.4-85.333 85.333v298.667c0 23.467 9.387 44.8 25.173 60.587l384 384c15.36 15.36 36.693 24.747 60.16 24.747s44.8-9.387 60.16-25.173l298.667-298.667c15.787-15.36 25.173-36.693 25.173-60.16s-9.813-45.227-25.173-60.587zM234.667 298.667c-35.413 0-64-28.587-64-64s28.587-64 64-64c35.413 0 64 28.587 64 64s-28.587 64-64 64zM736.853 651.52l-182.187 182.187-182.187-182.187c-19.2-19.627-31.147-46.080-31.147-75.52 0-58.88 47.787-106.667 106.667-106.667 29.44 0 56.32 11.947 75.52 31.573l31.147 30.72 31.147-31.147c19.2-19.2 46.080-31.147 75.52-31.147 58.88 0 106.667 47.787 106.667 106.667 0 29.44-11.947 56.32-31.147 75.52z',
      ],
      grid: 0,
      tags: ['coverage_active'],
      defaultCode: 59709,
    },
    {
      paths: [
        'M785.067 337.455h-341.333v69.818h341.333v418.909h-546.133v-418.909h68.267v139.636h68.267v-279.273h204.8v-139.636h-273.067v209.455h-68.267c-37.547 0-68.267 31.418-68.267 69.818v418.909c0 38.4 30.72 69.818 68.267 69.818h546.133c37.547 0 68.267-31.418 68.267-69.818v-418.909c0-38.4-30.72-69.818-68.267-69.818z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['order'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59679,
    },
    {
      paths: [
        'M785.067 337.455h-341.333v209.455h-68.267v-279.273h204.8v-139.636h-273.067v209.455h-68.267c-37.547 0-68.267 31.418-68.267 69.818v418.909c0 38.4 30.72 69.818 68.267 69.818h546.133c37.547 0 68.267-31.418 68.267-69.818v-418.909c0-38.4-30.72-69.818-68.267-69.818z',
      ],
      grid: 0,
      tags: ['order_active'],
      defaultCode: 59729,
    },
    {
      paths: [
        'M170.667 85.333l0.171 213.333 341.333 170.667 341.333-170.667-0.171-213.333h-682.667zM512.171 469.333l-79.104 154.496-176.811 24.747 127.915 120.277-30.165 169.813 158.165-80.171 158.080 80.171-30.165-169.813 127.915-120.32-176.853-24.747-78.976-154.453zM256.085 170.667h127.915v139.179l-127.915-63.915v-75.264zM469.333 170.667h85.333v182.016l-42.496 21.248-42.837-21.419v-181.845zM640 170.667h128.085v75.264l-128.085 64.085v-139.349z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['medal'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59792,
    },
    {
      paths: [
        'M170.667 85.333l0.171 213.333 341.333 170.667 341.333-170.667-0.171-213.333h-682.667zM512.171 469.333l-79.104 154.496-176.811 24.747 127.915 120.277-30.165 169.813 158.165-80.171 158.080 80.171-30.165-169.813 127.915-120.32-176.853-24.747-78.976-154.453zM426.667 170.667h170.667v160.683l-85.163 42.581-85.504-42.752v-160.512z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['medal_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59793,
    },
    {
      paths: [
        'M938.667 256c0-46.933-38.4-85.333-85.333-85.333h-682.667c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-512zM853.333 256l-341.333 213.333-341.333-213.333h682.667zM853.333 768h-682.667v-426.667l341.333 213.333 341.333-213.333v426.667z',
      ],
      grid: 0,
      tags: ['email'],
      defaultCode: 59665,
    },
    {
      paths: [
        'M853.333 170.667h-682.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM853.333 341.333l-341.333 213.333-341.333-213.333v-85.333l341.333 213.333 341.333-213.333v85.333z',
      ],
      grid: 0,
      tags: ['email_active'],
      defaultCode: 59715,
    },
    {
      paths: [
        'M512 938.667c46.933 0 85.333-38.4 85.333-85.333h-170.667c0 46.933 38.4 85.333 85.333 85.333zM768 682.667v-213.333c0-130.987-69.547-240.64-192-269.653v-29.013c0-35.413-28.587-64-64-64s-64 28.587-64 64v29.013c-122.027 29.013-192 138.24-192 269.653v213.333l-85.333 85.333v42.667h682.667v-42.667l-85.333-85.333zM682.667 725.333h-341.333v-256c0-105.813 64.427-192 170.667-192s170.667 86.187 170.667 192v256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['notification'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59678,
    },
    {
      paths: [
        'M768 661.333v-213.333c0-130.987-69.973-240.64-192-269.653v-29.013c0-35.413-28.587-64-64-64s-64 28.587-64 64v29.013c-122.453 29.013-192 138.24-192 269.653v213.333l-85.333 85.333v42.667h682.667v-42.667l-85.333-85.333zM512 917.333c46.933 0 85.333-38.4 85.333-85.333h-170.667c0 47.128 38.205 85.333 85.333 85.333v0z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['notification_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59794,
    },
    {
      paths: [
        'M309.895 473.6h-80.842v268.8h80.842v-268.8zM552.421 473.6h-80.842v268.8h80.842v-268.8zM896 819.2h-768v76.8h768v-76.8zM794.947 473.6h-80.842v268.8h80.842v-268.8zM512 214.784l210.594 105.216h-421.187l210.594-105.216zM512 128l-384 192v76.8h768v-76.8l-384-192z',
      ],
      grid: 0,
      tags: ['payments'],
      defaultCode: 59731,
    },
    {
      paths: [
        'M208.842 457.143v256h121.263v-256h-121.263zM451.368 457.143v256h121.263v-256h-121.263zM128 896h768v-109.714h-768v109.714zM693.895 457.143v256h121.263v-256h-121.263zM512 128l-384 182.857v73.143h768v-73.143l-384-182.857z',
      ],
      grid: 0,
      tags: ['payments_active'],
      defaultCode: 59730,
    },
    {
      paths: [
        'M783.36 384l25.6 128h-593.92l25.6-128h542.72zM853.333 170.667h-682.667v85.333h682.667v-85.333zM853.333 298.667h-682.667l-42.667 213.333v85.333h42.667v256h426.667v-256h170.667v256h85.333v-256h42.667v-85.333l-42.667-213.333zM256 768v-170.667h256v170.667h-256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['pharmacy'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59795,
    },
    {
      paths: [
        'M853.333 170.667h-682.667v85.333h682.667v-85.333zM896 597.333v-85.333l-42.667-213.333h-682.667l-42.667 213.333v85.333h42.667v256h426.667v-256h170.667v256h85.333v-256h42.667zM512 768h-256v-170.667h256v170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['pharmacy_active'],
      colorPermutations: {
        '12810122117474741': [{}],
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59734,
    },
    {
      paths: [
        'M896 256h-112.64l48.64-133.973-100.267-36.693-62.293 170.667h-541.44v85.333l85.333 256-85.333 256v85.333h768v-85.333l-85.333-256 85.333-256v-85.333zM729.6 624.213l76.373 229.12h-587.947l85.333-256-85.333-256h587.947l-85.333 256 8.96 26.88zM554.667 426.667h-85.333v128h-128v85.333h128v128h85.333v-128h128v-85.333h-128v-128z',
      ],
      grid: 0,
      tags: ['pharmacy'],
      defaultCode: 59680,
    },
    {
      paths: [
        'M896 256h-112.64l48.64-133.973-100.267-36.693-62.293 170.667h-541.44v85.333l85.333 256-85.333 256v85.333h768v-85.333l-85.333-256 85.333-256v-85.333zM682.667 640h-128v128h-85.333v-128h-128v-85.333h128v-128h85.333v128h128v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['prescription_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59796,
    },
    {
      paths: [
        'M829.013 553.813c1.707-13.653 2.987-27.307 2.987-41.813s-1.28-28.16-2.987-41.813l90.027-70.4c8.107-6.4 10.24-17.92 5.12-27.307l-85.333-147.627c-3.84-6.827-11.093-10.667-18.773-10.667-2.56 0-5.12 0.427-7.253 1.28l-106.24 42.667c-22.187-17.067-46.080-31.147-72.107-41.813l-16.213-113.067c-1.28-10.24-10.24-17.92-20.907-17.92h-170.667c-10.667 0-19.627 7.68-20.907 17.92l-16.213 113.067c-26.027 10.667-49.92 25.173-72.107 41.813l-106.24-42.667c-2.56-0.853-5.12-1.28-7.68-1.28-7.253 0-14.507 3.84-18.347 10.667l-85.333 147.627c-5.547 9.387-2.987 20.907 5.12 27.307l90.027 70.4c-1.707 13.653-2.987 27.733-2.987 41.813s1.28 28.16 2.987 41.813l-90.027 70.4c-8.107 6.4-10.24 17.92-5.12 27.307l85.333 147.627c3.84 6.827 11.093 10.667 18.773 10.667 2.56 0 5.12-0.427 7.253-1.28l106.24-42.667c22.187 17.067 46.080 31.147 72.107 41.813l16.213 113.067c1.28 10.24 10.24 17.92 20.907 17.92h170.667c10.667 0 19.627-7.68 20.907-17.92l16.213-113.067c26.027-10.667 49.92-25.173 72.107-41.813l106.24 42.667c2.56 0.853 5.12 1.28 7.68 1.28 7.253 0 14.507-3.84 18.347-10.667l85.333-147.627c5.12-9.387 2.987-20.907-5.12-27.307l-90.027-70.4zM744.533 480.853c1.707 13.227 2.133 22.187 2.133 31.147s-0.853 18.347-2.133 31.147l-5.973 48.213 37.973 29.867 46.080 35.84-29.867 51.627-54.187-21.76-44.373-17.92-38.4 29.013c-18.347 13.653-35.84 23.893-53.333 31.147l-45.227 18.347-6.827 48.213-8.533 57.6h-59.733l-8.107-57.6-6.827-48.213-45.227-18.347c-18.347-7.68-35.413-17.493-52.48-30.293l-38.827-29.867-45.227 18.347-54.187 21.76-29.867-51.627 46.080-35.84 37.973-29.867-5.973-48.213c-1.28-13.227-2.133-23.040-2.133-31.573s0.853-18.347 2.133-31.147l5.973-48.213-37.973-29.867-46.080-35.84 29.867-51.627 54.187 21.76 44.373 17.92 38.4-29.013c18.347-13.653 35.84-23.893 53.333-31.147l45.227-18.347 6.827-48.213 8.533-57.6h59.307l8.107 57.6 6.827 48.213 45.227 18.347c18.347 7.68 35.413 17.493 52.48 30.293l38.827 29.867 45.227-18.347 54.187-21.76 29.867 51.627-45.653 36.267-37.973 29.867 5.973 48.213zM512 341.333c-94.293 0-170.667 76.373-170.667 170.667s76.373 170.667 170.667 170.667c94.293 0 170.667-76.373 170.667-170.667s-76.373-170.667-170.667-170.667zM512 597.333c-46.933 0-85.333-38.4-85.333-85.333s38.4-85.333 85.333-85.333c46.933 0 85.333 38.4 85.333 85.333s-38.4 85.333-85.333 85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['settings'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59685,
    },
    {
      paths: [
        'M816.64 551.936c1.536-12.8 2.56-26.112 2.56-39.936s-1.024-27.136-3.072-39.936l86.528-67.584c7.68-6.144 9.728-17.408 5.12-26.112l-81.92-141.824c-5.12-9.216-15.872-12.288-25.088-9.216l-101.888 40.96c-21.504-16.384-44.032-29.696-69.12-39.936l-15.36-108.544c-1.536-10.24-10.24-17.408-20.48-17.408h-163.84c-10.24 0-18.432 7.168-19.968 17.408l-15.36 108.544c-25.088 10.24-48.128 24.064-69.12 39.936l-101.888-40.96c-9.216-3.584-19.968 0-25.088 9.216l-81.92 141.824c-5.12 9.216-3.072 19.968 5.12 26.112l86.528 67.584c-2.048 12.8-3.584 26.624-3.584 39.936s1.024 27.136 3.072 39.936l-86.528 67.584c-7.68 6.144-9.728 17.408-5.12 26.112l81.92 141.824c5.12 9.216 15.872 12.288 25.088 9.216l101.888-40.96c21.504 16.384 44.032 29.696 69.12 39.936l15.36 108.544c2.048 10.24 10.24 17.408 20.48 17.408h163.84c10.24 0 18.944-7.168 19.968-17.408l15.36-108.544c25.088-10.24 48.128-24.064 69.12-39.936l101.888 40.96c9.216 3.584 19.968 0 25.088-9.216l81.92-141.824c5.12-9.216 3.072-19.968-5.12-26.112l-85.504-67.584zM512 665.6c-84.48 0-153.6-69.12-153.6-153.6s69.12-153.6 153.6-153.6c84.48 0 153.6 69.12 153.6 153.6s-69.12 153.6-153.6 153.6z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['settings_active'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59742,
    },
    {
      paths: [
        'M640 170.667v298.667h-419.413l-49.92 49.92v-348.587h469.333zM682.667 85.333h-554.667c-23.467 0-42.667 19.2-42.667 42.667v597.333l170.667-170.667h426.667c23.467 0 42.667-19.2 42.667-42.667v-384c0-23.467-19.2-42.667-42.667-42.667zM896 256h-85.333v384h-554.667v85.333c0 23.467 19.2 42.667 42.667 42.667h469.333l170.667 170.667v-640c0-23.467-19.2-42.667-42.667-42.667z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['support'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59687,
    },
    {
      paths: [
        'M896 256h-85.333v384h-554.667v85.333c0 23.467 19.2 42.667 42.667 42.667h469.333l170.667 170.667v-640c0-23.467-19.2-42.667-42.667-42.667zM725.333 512v-384c0-23.467-19.2-42.667-42.667-42.667h-554.667c-23.467 0-42.667 19.2-42.667 42.667v597.333l170.667-170.667h426.667c23.467 0 42.667-19.2 42.667-42.667z',
      ],
      grid: 0,
      tags: ['support_active'],
      defaultCode: 59744,
    },
    {
      paths: [
        'M807.253 256.427c-8.533-25.173-32.427-43.093-60.587-43.093h-106.667v-85.333h-256v85.333h-106.667c-28.16 0-51.627 17.92-60.587 43.093l-88.747 255.573v341.333c0 23.467 19.2 42.667 42.667 42.667h42.667c23.467 0 42.667-19.2 42.667-42.667v-42.667h512v42.667c0 23.467 19.2 42.667 42.667 42.667h42.667c23.467 0 42.667-19.2 42.667-42.667v-341.333l-88.747-255.573zM292.267 298.667h439.040l44.373 128h-527.787l44.373-128zM810.667 725.333h-597.333v-198.827l5.12-14.507h587.52l4.693 14.507v198.827z',
        'M384 618.667c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z',
        'M768 618.667c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['taxi'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59797,
    },
    {
      paths: [
        'M807.253 256.427c-8.533-25.173-32.427-43.093-60.587-43.093h-106.667v-85.333h-256v85.333h-106.667c-28.16 0-51.627 17.92-60.587 43.093l-88.747 255.573v341.333c0 23.467 19.2 42.667 42.667 42.667h42.667c23.467 0 42.667-19.2 42.667-42.667v-42.667h512v42.667c0 23.467 19.2 42.667 42.667 42.667h42.667c23.467 0 42.667-19.2 42.667-42.667v-341.333l-88.747-255.573zM277.333 682.667c-35.413 0-64-28.587-64-64s28.587-64 64-64 64 28.587 64 64-28.587 64-64 64zM746.667 682.667c-35.413 0-64-28.587-64-64s28.587-64 64-64 64 28.587 64 64-28.587 64-64 64zM213.333 469.333l64-192h469.333l64 192h-597.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['taxi_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59798,
    },
    {
      paths: [
        'M857.6 328.533l-42.667 42.667c76.8 76.8 76.8 196.267 0 277.333l42.667 42.667c106.667-98.133 106.667-260.267 0-362.667zM768 418.133l-42.667 42.667c21.333 29.867 21.333 68.267 0 98.133l42.667 42.667c51.2-51.2 51.2-128 0-183.467zM597.333 42.667h-426.667c-46.933 0-85.333 38.4-85.333 85.333v768c0 46.933 38.4 85.333 85.333 85.333h426.667c46.933 0 85.333-38.4 85.333-85.333v-768c0-46.933-38.4-85.333-85.333-85.333zM597.333 853.333h-426.667v-682.667h426.667v682.667zM332.8 682.667h102.4v-119.467h119.467v-102.4h-119.467v-119.467h-102.4v119.467h-119.467v102.4h119.467v119.467z',
      ],
      grid: 0,
      tags: ['telemedicine'],
      defaultCode: 59746,
    },
    {
      paths: [
        'M857.6 328.533l-42.667 42.667c76.8 76.8 76.8 196.267 0 277.333l42.667 42.667c106.667-98.133 106.667-260.267 0-362.667zM768 418.133l-42.667 42.667c21.333 29.867 21.333 68.267 0 98.133l42.667 42.667c51.2-51.2 51.2-128 0-183.467zM597.333 42.667c46.933 0 85.333 38.4 85.333 85.333v768c0 46.933-38.4 85.333-85.333 85.333h-426.667c-46.933 0-85.333-38.4-85.333-85.333v-768c0-46.933 38.4-85.333 85.333-85.333h426.667zM332.8 682.667h102.4v-119.467h119.467v-102.4h-119.467v-119.467h-102.4v119.467h-119.467v102.4h119.467v119.467z',
      ],
      grid: 0,
      tags: ['telemedicine_active'],
      defaultCode: 59745,
    },
    {
      paths: [
        'M512 384c94.293 0 170.667-76.373 170.667-170.667s-76.373-170.667-170.667-170.667-170.667 76.373-170.667 170.667 76.373 170.667 170.667 170.667zM512 128c46.933 0 85.333 38.4 85.333 85.333s-38.4 85.333-85.333 85.333-85.333-38.4-85.333-85.333 38.4-85.333 85.333-85.333zM512 492.8c-100.693-93.867-235.52-151.467-384-151.467v469.333c148.48 0 283.307 57.6 384 151.467 100.693-93.44 235.52-151.467 384-151.467v-469.333c-148.48 0-283.307 57.6-384 151.467zM810.667 730.88c-107.947 14.507-210.347 55.467-298.667 120.32-87.893-64.853-190.72-106.24-298.667-120.747v-296.533c89.6 16.213 172.8 57.6 240.64 120.747l58.027 54.613 58.027-54.187c67.84-63.147 151.040-104.533 240.64-120.747v296.533z',
      ],
      grid: 0,
      tags: ['outline-local_library-24px'],
      defaultCode: 59761,
    },
    {
      paths: [
        'M512 492.8c-100.693-93.867-235.52-151.467-384-151.467v469.333c148.48 0 283.307 57.6 384 151.467 100.693-93.44 235.52-151.467 384-151.467v-469.333c-148.48 0-283.307 57.6-384 151.467zM512 341.333c70.827 0 128-57.173 128-128s-57.173-128-128-128-128 57.173-128 128 57.173 128 128 128z',
      ],
      grid: 0,
      tags: ['baseline-local_library-24px'],
      defaultCode: 59760,
    },
    {
      paths: [
        'M328.704 85.333l-37.333 29.739c-10.197 8.107-248.704 201.259-248.704 451.115 0 145.152 73.685 217.344 124.245 250.24-14.293 17.067-27.093 34.219-37.675 51.072-24.491 39.083-40.32 75.349-40.32 113.792h92.587c0-7.68 7.296-34.859 26.197-64.939 5.205-8.363 11.349-17.067 18.048-25.856 29.696 9.259 150.613 44.672 279.595 44.672 124.928 0 218.88-39.253 289.536-96.939 70.741-57.685 119.125-131.157 165.376-200.363l21.077-31.445-26.88-26.752s-148.352-151.893-356.565-151.893c-127.189 0-220.459 68.267-284.757 146.219 4.139-47.317 7.168-96.128 7.168-146.176h-92.587c0 108.8-13.611 220.971-30.080 296.021-29.44-26.539-62.421-74.112-62.421-157.653 0-151.168 114.944-284.459 176.384-344.875 23.68 38.485 56.96 99.499 78.805 168.107 24.426-14.001 52.729-26.309 82.425-35.433l2.993-0.791c-41.941-126.549-114.219-224.128-118.485-229.803l-28.629-38.059zM638.507 512c129.963 0 219.819 72.661 257.493 106.112-37.333 57.6-73.387 115.2-119.253 154.88-56.448 48.64-124.373 80.341-230.613 80.341-84.608 0-156.928-17.067-204.8-30.379 73.515-63.957 175.573-115.925 297.173-115.925v-97.493c-89.984 0-170.624 23.723-239.872 59.435 52.992-83.883 128.555-156.971 239.872-156.971z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['wellness_2'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59799,
    },
    {
      paths: [
        'M328.704 85.333l-37.333 29.739c-10.197 8.107-248.704 201.259-248.704 451.115 0 133.205 62.507 205.568 111.872 242.048-10.155 16.555-19.627 32.939-27.477 48.64-23.509 46.933-38.144 85.973-38.144 124.416h92.587c0-7.68 8.533-43.563 28.331-83.157 25.287-48.978 54.347-91.21 87.971-129.321l-0.589 0.681c65.621-74.709 153.173-138.283 254.421-153.6l3.072-0.427c14.123-2.005 28.544-3.157 43.179-3.157v92.245c-128.981 0-230.912 106.965-288 207.531 54.187 11.733 124.843 23.083 195.456 23.083 256.128 0 361.728-157.952 454.912-297.301l21.077-31.445-26.88-26.752c-6.187-6.229-154.624-151.893-356.565-151.893-128.128 0-220.16 66.304-284.757 145.067 4.285-43.099 6.882-93.568 7.166-144.585l0.002-0.482h-92.587c0 109.653-13.483 220.501-30.293 295.851-29.44-26.539-62.208-74.155-62.208-157.44 0-151.168 114.944-284.459 176.384-344.875 23.68 38.485 56.96 99.499 78.805 168.107 24.426-14.001 52.729-26.309 82.425-35.433l2.993-0.791c-41.941-126.549-114.219-224.128-118.485-229.803l-28.629-38.059z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['wellness_2_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59800,
    },
    {
      paths: [
        'M597.333 256v-85.333h-170.667v85.333h170.667zM170.667 341.333v469.333h682.667v-469.333h-682.667zM853.333 256c47.36 0 85.333 37.973 85.333 85.333v469.333c0 47.36-37.973 85.333-85.333 85.333h-682.667c-47.36 0-85.333-37.973-85.333-85.333l0.427-469.333c0-47.36 37.547-85.333 84.907-85.333h170.667v-85.333c0-47.36 37.973-85.333 85.333-85.333h170.667c47.36 0 85.333 37.973 85.333 85.333v85.333h170.667z',
      ],
      grid: 0,
      tags: ['baseline-work_outline-24px'],
      defaultCode: 59775,
    },
    {
      paths: [
        'M853.333 298.667h-170.667v-85.333c0-47.36-37.973-85.333-85.333-85.333h-170.667c-47.36 0-85.333 37.973-85.333 85.333v85.333h-170.667c-47.36 0-84.907 37.973-84.907 85.333l-0.427 469.333c0 47.36 37.973 85.333 85.333 85.333h682.667c47.36 0 85.333-37.973 85.333-85.333v-469.333c0-47.36-37.973-85.333-85.333-85.333zM597.333 298.667h-170.667v-85.333h170.667v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['briefcase_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59801,
    },
    {
      paths: [
        'M597.333 85.333h-341.333c-46.933 0-84.907 38.4-84.907 85.333l-0.427 682.667c0 46.933 37.973 85.333 84.907 85.333h512.427c46.933 0 85.333-38.4 85.333-85.333v-512l-256-256zM256 853.333v-682.667h298.667v213.333h213.333v469.333h-512z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['claims'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59656,
    },
    {
      paths: [
        'M256 85.333c-46.933 0-84.907 38.4-84.907 85.333l-0.427 682.667c0 46.933 37.973 85.333 84.907 85.333h512.427c46.933 0 85.333-38.4 85.333-85.333v-512l-256-256h-341.333zM554.667 384v-234.667l234.667 234.667h-234.667z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['claims_active'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59707,
    },
    {
      paths: [
        'M853.333 256h-341.333l-85.333-85.333h-256c-46.933 0-84.907 38.4-84.907 85.333l-0.427 512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM853.333 768h-682.667v-426.667h682.667v426.667z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['documents'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59660,
    },
    {
      paths: [
        'M426.667 170.667h-256c-46.933 0-84.907 38.4-84.907 85.333l-0.427 512c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333h-341.333l-85.333-85.333z',
      ],
      grid: 0,
      tags: ['documents_active'],
      defaultCode: 59712,
    },
    {
      paths: [
        'M298.667 640h298.667v85.333h-298.667v-85.333zM298.667 469.333h426.667v85.333h-426.667v-85.333zM298.667 298.667h426.667v85.333h-426.667v-85.333zM810.667 128h-178.347c-17.92-49.493-64.853-85.333-120.32-85.333s-102.4 35.84-120.32 85.333h-178.347c-5.973 0-11.52 0.427-17.067 1.707-16.64 3.413-31.573 11.947-43.093 23.467-7.68 7.68-14.080 17.067-18.347 27.307-4.267 9.813-6.827 20.907-6.827 32.853v597.333c0 11.52 2.56 23.040 6.827 33.28s10.667 19.2 18.347 27.307c11.52 11.52 26.453 20.053 43.093 23.467 5.547 0.853 11.093 1.28 17.067 1.28h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM512 117.333c17.493 0 32 14.507 32 32s-14.507 32-32 32c-17.493 0-32-14.507-32-32s14.507-32 32-32zM810.667 810.667h-597.333v-597.333h597.333v597.333z',
      ],
      grid: 0,
      tags: ['hra'],
      defaultCode: 59724,
    },
    {
      paths: [
        'M810.667 128h-178.347c-17.92-49.493-64.853-85.333-120.32-85.333s-102.4 35.84-120.32 85.333h-178.347c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM512 128c23.467 0 42.667 19.2 42.667 42.667s-19.2 42.667-42.667 42.667c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667zM597.333 725.333h-298.667v-85.333h298.667v85.333zM725.333 554.667h-426.667v-85.333h426.667v85.333zM725.333 384h-426.667v-85.333h426.667v85.333z',
      ],
      grid: 0,
      tags: ['hra_active'],
      defaultCode: 59723,
    },
    {
      paths: [
        'M896 192c-47.36-14.933-99.413-21.333-149.333-21.333-83.2 0-172.8 17.067-234.667 64-61.867-46.933-151.467-64-234.667-64s-172.8 17.067-234.667 64v625.067c0 10.667 10.667 21.333 21.333 21.333 4.267 0 6.4-2.133 10.667-2.133 57.6-27.733 140.8-46.933 202.667-46.933 83.2 0 172.8 17.067 234.667 64 57.6-36.267 162.133-64 234.667-64 70.4 0 142.933 12.8 202.667 44.8 4.267 2.133 6.4 2.133 10.667 2.133 10.667 0 21.333-10.667 21.333-21.333v-622.933c-25.6-19.2-53.333-32-85.333-42.667zM896 768c-41.719-14.933-87.23-21.333-132.741-21.333-64.474 0-157.393 27.733-208.593 64v-490.667c51.2-36.267 144.119-64 208.593-64 45.511 0 91.022 6.4 132.741 21.333v490.667zM128 768v-490.667c41.719-14.933 87.23-21.333 132.741-21.333 64.474 0 157.393 27.733 208.593 64v490.667c-51.2-36.267-144.119-64-208.593-64-45.511 0-91.022 6.4-132.741 21.333z',
      ],
      grid: 0,
      tags: ['healthwise'],
      defaultCode: 59720,
    },
    {
      paths: [
        'M896 213.333c-47.36-14.933-99.413-21.333-149.333-21.333-83.2 0-172.8 17.067-234.667 64-61.867-46.933-151.467-64-234.667-64s-172.8 17.067-234.667 64v625.067c0 10.667 10.667 21.333 21.333 21.333 4.267 0 6.4-2.133 10.667-2.133 57.6-27.733 140.8-46.933 202.667-46.933 83.2 0 172.8 17.067 234.667 64 57.6-36.267 162.133-64 234.667-64 70.4 0 142.933 12.8 202.667 44.8 4.267 2.133 6.4 2.133 10.667 2.133 10.667 0 21.333-10.667 21.333-21.333v-622.933c-25.6-19.2-53.333-32-85.333-42.667zM896 789.333c-46.933-14.933-98.133-21.333-149.333-21.333-72.533 0-177.067 27.733-234.667 64v-490.667c57.6-36.267 162.133-64 234.667-64 51.2 0 102.4 6.4 149.333 21.333v490.667z',
      ],
      grid: 0,
      tags: ['healthwise_active'],
      defaultCode: 59719,
    },
    {
      paths: [
        'M853.333 85.333h-512c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM853.333 682.667h-512v-512h512v512zM170.667 256h-85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333v-85.333h-597.333v-597.333zM682.667 512v-128c0-23.467-19.2-42.667-42.667-42.667h-85.333v213.333h85.333c23.467 0 42.667-19.2 42.667-42.667zM597.333 384h42.667v128h-42.667v-128zM768 469.333h42.667v-42.667h-42.667v-42.667h42.667v-42.667h-85.333v213.333h42.667v-85.333zM426.667 469.333h42.667c23.467 0 42.667-19.2 42.667-42.667v-42.667c0-23.467-19.2-42.667-42.667-42.667h-85.333v213.333h42.667v-85.333zM426.667 384h42.667v42.667h-42.667v-42.667z',
      ],
      grid: 0,
      tags: ['pdf'],
      defaultCode: 59733,
    },
    {
      paths: [
        'M853.333 85.333h-512c-46.933 0-85.333 38.4-85.333 85.333v512c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-512c0-46.933-38.4-85.333-85.333-85.333zM490.667 405.333c0 35.413-28.587 64-64 64h-42.667v85.333h-64v-256h106.667c35.413 0 64 28.587 64 64v42.667zM704 490.667c0 35.413-28.587 64-64 64h-106.667v-256h106.667c35.413 0 64 28.587 64 64v128zM874.667 362.667h-64v42.667h64v64h-64v85.333h-64v-256h128v64zM384 405.333h42.667v-42.667h-42.667v42.667zM170.667 256h-85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333v-85.333h-597.333v-597.333zM597.333 490.667h42.667v-128h-42.667v128z',
      ],
      grid: 0,
      tags: ['pdf_active'],
      defaultCode: 59732,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667h213.333v-85.333h-213.333c-185.173 0-341.333-156.16-341.333-341.333s156.16-341.333 341.333-341.333 341.333 156.16 341.333 341.333v61.013c0 33.707-30.293 66.987-64 66.987s-64-33.28-64-66.987v-61.013c0-117.76-95.573-213.333-213.333-213.333s-213.333 95.573-213.333 213.333 95.573 213.333 213.333 213.333c58.88 0 112.64-23.893 151.040-62.72 27.733 37.973 75.52 62.72 126.293 62.72 84.053 0 149.333-68.267 149.333-152.32v-61.013c0-235.52-191.147-426.667-426.667-426.667zM512 640c-70.827 0-128-57.173-128-128s57.173-128 128-128 128 57.173 128 128-57.173 128-128 128z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['send_to'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59802,
    },
    {
      paths: [
        'M810.667 554.667h-256v256h-85.333v-256h-256v-85.333h256v-256h85.333v256h256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['add'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59649,
    },
    {
      paths: [
        'M876.373 223.147l-59.307-71.68c-11.52-14.507-29.013-23.467-49.067-23.467h-512c-20.053 0-37.547 8.96-49.493 23.467l-58.88 71.68c-12.373 14.507-19.627 33.707-19.627 54.187v533.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-533.333c0-20.48-7.253-39.68-19.627-54.187zM266.24 213.333h491.52l34.56 41.387h-560.213l34.133-41.387zM213.333 810.667v-469.333h597.333v469.333h-597.333zM573.867 426.667h-123.733v128h-108.8l170.667 170.667 170.667-170.667h-108.8v-128z',
      ],
      grid: 0,
      tags: ['archive'],
      defaultCode: 59691,
    },
    {
      paths: [
        'M876.373 223.147l-59.307-71.68c-11.52-14.507-29.013-23.467-49.067-23.467h-512c-20.053 0-37.547 8.96-49.493 23.467l-58.88 71.68c-12.373 14.507-19.627 33.707-19.627 54.187v533.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-533.333c0-20.48-7.253-39.68-19.627-54.187zM512 746.667l-234.667-234.667h149.333v-85.333h170.667v85.333h149.333l-234.667 234.667zM218.453 213.333l34.56-42.667h512l40.107 42.667h-586.667z',
      ],
      grid: 0,
      tags: ['archive_active'],
      defaultCode: 59690,
    },
    {
      paths: [
        'M704 256v490.667c0 94.293-76.373 170.667-170.667 170.667s-170.667-76.373-170.667-170.667v-533.333c0-58.91 47.756-106.667 106.667-106.667s106.667 47.756 106.667 106.667v0 448c0 23.467-19.2 42.667-42.667 42.667s-42.667-19.2-42.667-42.667v-405.333h-64v405.333c0 58.91 47.756 106.667 106.667 106.667s106.667-47.756 106.667-106.667v0-448c0-94.293-76.373-170.667-170.667-170.667s-170.667 76.373-170.667 170.667v533.333c0 129.707 104.96 234.667 234.667 234.667s234.667-104.96 234.667-234.667v-490.667h-64z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['attachment'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59803,
    },
    {
      paths: [
        'M853.333 128h-42.667v-85.333h-85.333v85.333h-426.667v-85.333h-85.333v85.333h-42.667c-46.933 0-85.333 38.4-85.333 85.333v682.667c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-682.667c0-46.933-38.4-85.333-85.333-85.333zM853.333 896h-682.667v-469.333h682.667v469.333zM853.333 341.333h-682.667v-128h682.667v128z',
      ],
      grid: 0,
      tags: ['outline-calendar_today-24px'],
      defaultCode: 59664,
    },
    {
      paths: [
        'M853.333 128h-42.667v-85.333h-85.333v85.333h-426.667v-85.333h-85.333v85.333h-42.667c-46.933 0-85.333 38.4-85.333 85.333v682.667c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333v-682.667c0-46.933-38.4-85.333-85.333-85.333zM853.333 896h-682.667v-554.667h682.667v554.667z',
      ],
      grid: 0,
      tags: ['calendar'],
      defaultCode: 59652,
    },
    {
      paths: [
        'M810.667 213.333v597.333h-597.333v-597.333h597.333zM810.667 128h-597.333c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['checkbox'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59655,
    },
    {
      paths: [
        'M810.667 128h-597.333c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h597.333c47.36 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-37.973-85.333-85.333-85.333zM426.667 725.333l-213.333-213.333 60.16-60.16 153.173 152.747 323.84-323.84 60.16 60.587-384 384z',
      ],
      grid: 0,
      tags: ['checkbox_active'],
      defaultCode: 59702,
    },
    {
      paths: [
        'M810.667 128h-597.333c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333zM725.333 554.667h-426.667v-85.333h426.667v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['checkbox_all'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59804,
    },
    {
      paths: [
        'M853.333 239.421l-68.754-68.754-272.579 272.579-272.579-272.579-68.754 68.754 272.579 272.579-272.579 272.579 68.754 68.754 272.579-272.579 272.579 272.579 68.754-68.754-272.579-272.579z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['close'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59657,
    },
    {
      paths: [
        'M256 810.667c0 46.933 38.4 85.333 85.333 85.333h341.333c46.933 0 85.333-38.4 85.333-85.333v-512h-512v512zM341.333 384h341.333v426.667h-341.333v-426.667zM661.333 170.667l-42.667-42.667h-213.333l-42.667 42.667h-149.333v85.333h597.333v-85.333h-149.333z',
      ],
      grid: 0,
      tags: ['trash'],
      defaultCode: 59748,
    },
    {
      paths: [
        'M256 810.667c0 46.933 38.4 85.333 85.333 85.333h341.333c46.933 0 85.333-38.4 85.333-85.333v-512h-512v512zM810.667 170.667h-149.333l-42.667-42.667h-213.333l-42.667 42.667h-149.333v85.333h597.333v-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['delete_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59805,
    },
    {
      paths: [
        'M956.8 451.243l-384.427-384.427c-32-32-88.32-32.427-120.747 0l-384 384c-33.28 33.28-33.28 87.040 0 120.32l384 384c16.64 16.64 38.4 24.747 60.16 24.747s43.52-8.107 60.16-24.747l383.573-383.573c33.707-32.427 34.133-86.187 1.28-120.32zM512.213 894.976l-384-384 384-384 384 384-384 384zM341.12 468.736v170.667h85.333v-128h170.667v106.667l149.333-149.333-149.333-149.333v106.667h-213.333c-23.467 0-42.667 19.2-42.667 42.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['directions'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59806,
    },
    {
      paths: [
        'M925.995 481.835l-384-384c-7.693-7.709-18.33-12.478-30.080-12.478s-22.387 4.769-30.079 12.477l-0.001 0.001-384 384c-7.709 7.693-12.478 18.33-12.478 30.080s4.769 22.387 12.477 30.079l0.001 0.001 384 384c16.64 16.64 43.52 16.64 60.16 0l384-384c7.709-7.693 12.478-18.33 12.478-30.080s-4.769-22.387-12.477-30.079l-0.001-0.001zM597.035 618.795v-106.667h-170.667v128h-85.333v-170.667c0-23.467 19.2-42.667 42.667-42.667h213.333v-106.667l149.333 149.333-149.333 149.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['directions_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59807,
    },
    {
      paths: [
        'M725.333 42.667h-512c-46.933 0-85.333 38.4-85.333 85.333v597.333h85.333v-597.333h512v-85.333zM682.667 213.333h-298.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 597.333c0 46.933 37.973 85.333 84.907 85.333h469.76c46.933 0 85.333-38.4 85.333-85.333v-426.667l-256-256zM384 896v-597.333h256v213.333h213.333v384h-469.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['document_upload'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59808,
    },
    {
      paths: [
        'M725.333 42.667h-512c-46.933 0-85.333 38.4-85.333 85.333v597.333h85.333v-597.333h512v-85.333zM682.667 213.333l256 256v426.667c0 46.933-38.4 85.333-85.333 85.333h-469.76c-46.933 0-84.907-38.4-84.907-85.333l0.427-597.333c0-46.933 37.973-85.333 84.907-85.333h298.667zM640 512h234.667l-234.667-234.667v234.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['document_upload_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59809,
    },
    {
      paths: [
        'M554.667 213.333v256h49.92l-92.587 92.587-92.587-92.587h49.92v-256h85.333zM640 128h-256v256h-170.667l298.667 298.667 298.667-298.667h-170.667v-256zM810.667 768h-597.333v85.333h597.333v-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['download'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59661,
    },
    {
      paths: [
        'M810.667 384h-170.667v-256h-256v256h-170.667l298.667 298.667 298.667-298.667zM213.333 768v85.333h597.333v-85.333h-597.333z',
      ],
      grid: 0,
      tags: ['download_active'],
      defaultCode: 59713,
    },
    {
      paths: [
        'M599.893 384.853l39.253 39.253-386.56 386.56h-39.253v-39.253l386.56-386.56zM753.493 128c-10.667 0-21.76 4.267-29.867 12.373l-78.080 78.080 160 160 78.080-78.080c16.64-16.64 16.64-43.52 0-60.16l-99.84-99.84c-8.533-8.533-19.2-12.373-30.293-12.373zM599.893 264.107l-471.893 471.893v160h160l471.893-471.893-160-160z',
      ],
      grid: 0,
      tags: ['edit'],
      defaultCode: 59662,
    },
    {
      paths: [
        'M128 736.107v160h160l471.893-471.893-160-160-471.893 471.893zM883.627 300.48c16.64-16.64 16.64-43.52 0-60.16l-99.84-99.84c-16.64-16.64-43.52-16.64-60.16 0l-78.080 78.080 160 160 78.080-78.080z',
      ],
      grid: 0,
      tags: ['edit_active'],
      defaultCode: 59714,
    },
    {
      paths: [
        'M640 128l98.133 98.133-123.307 122.453 60.587 60.587 122.453-123.307 98.133 98.133v-256h-256zM128 384l98.133-98.133 122.453 123.307 60.587-60.587-123.307-122.453 98.133-98.133h-256v256zM384 896l-98.133-98.133 123.307-122.453-60.587-60.587-122.453 123.307-98.133-98.133v256h256zM896 640l-98.133 98.133-122.453-123.307-60.587 60.587 123.307 122.453-98.133 98.133h256v-256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['enlarge'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59666,
    },
    {
      paths: [
        'M682.667 136.533c235.21 0 444.975 145.408 547.375 375.467-102.4 230.059-311.544 375.467-547.375 375.467s-444.975-145.408-547.375-375.467c102.4-230.059 312.165-375.467 547.375-375.467v0zM682.667 0c-310.303 0-575.302 212.309-682.667 512 107.365 299.691 372.364 512 682.667 512s575.302-212.309 682.667-512c-107.365-299.691-372.364-512-682.667-512zM682.667 341.333c85.644 0 155.152 76.459 155.152 170.667s-69.508 170.667-155.152 170.667c-85.644 0-155.152-76.459-155.152-170.667s69.508-170.667 155.152-170.667v0zM682.667 204.8c-153.91 0-279.273 137.899-279.273 307.2s125.362 307.2 279.273 307.2c153.91 0 279.273-137.899 279.273-307.2s-125.362-307.2-279.273-307.2z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      width: 1365,
      grid: 0,
      tags: ['eye-resting'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59810,
    },
    {
      paths: [
        'M178.998 0l-76.819 78.636 124.354 127.294c-144.877 119.245-213.020 273.605-217.407 284.131l-9.125 21.94 9.125 21.94c7.225 17.295 181.877 422.938 593.228 422.938 112.255 0 206.284-30.611 284.571-74.943l138.784 142.065 76.819-78.636-923.53-945.364zM602.353 67.123c-65.788 0-124.946 11.157-178.892 28.674l89.446 91.56c28.303-5.505 57.883-9.015 89.446-9.015 293.139 0 443.709 255.142 482.986 333.441-15.972 31.308-50.972 92.082-105.786 153.252l77.456 79.287c91.266-101.098 135.041-201.986 138.572-210.383l9.125-21.94-9.125-21.94c-7.225-17.295-181.877-422.938-593.228-422.938zM304.2 285.434l111.409 114.043c-19.261 32.949-30.558 71.31-30.558 112.523 0 122.675 97.46 222.439 217.301 222.439 40.261 0 77.736-11.564 109.924-31.28l93.69 95.905c-58.329 28.312-126.021 46.595-203.614 46.595-293.139 0-443.709-255.142-482.986-333.441 22.579-44.263 83.165-146.87 184.833-226.783zM613.918 290.756l204.569 209.405c-5.921-113.054-94.125-203.344-204.569-209.405zM497.734 483.543l132.418 135.549c-8.897 2.448-18.134 4.127-27.799 4.127-59.921 0-108.651-49.882-108.651-111.219 0-9.894 1.64-19.349 4.032-28.457z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      width: 1205,
      grid: 0,
      tags: ['eye-hide-resting'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59830,
    },
    {
      paths: [
        'M512 192c-213.333 0-395.52 132.693-469.333 320 73.813 187.307 256 320 469.333 320s395.52-132.693 469.333-320c-73.813-187.307-256-320-469.333-320zM512 725.333c-117.76 0-213.333-95.573-213.333-213.333s95.573-213.333 213.333-213.333 213.333 95.573 213.333 213.333-95.573 213.333-213.333 213.333zM512 384c-70.827 0-128 57.173-128 128s57.173 128 128 128 128-57.173 128-128-57.173-128-128-128z',
      ],
      grid: 0,
      tags: ['baseline-remove_red_eye-24px'],
      defaultCode: 59774,
    },
    {
      paths: [
        'M209.707 170.667l-54.827 54.869 88.576 88.491c-111.616 91.136-158.123 213.76-158.123 213.76s116.352 310.315 426.667 310.315c80.512 0 147.627-21.163 203.349-52.139l98.944 98.987 54.827-54.869-659.413-659.413zM512 217.472c-0.007-0-0.015-0-0.023-0-45.492 0-89.29 7.258-130.297 20.678l2.96-0.838 99.328 99.328c9.173-1.365 18.432-2.773 28.032-2.773 107.089 0.024 193.896 86.831 193.92 193.918l0 0.002c0 9.6-1.408 18.859-2.773 28.032l133.035 133.035c71.637-79.573 102.485-161.067 102.485-161.067s-116.352-310.315-426.667-310.315zM350.421 421.035l56.747 56.747c-7.265 14.604-11.518 31.808-11.52 50.004l-0 0.001c0 64.259 52.093 116.352 116.352 116.352v0c18.197-0.002 35.401-4.255 50.673-11.819l-0.667 0.299 56.747 56.747c-29.995 20.258-66.963 32.339-106.752 32.341l-0 0c-107.089-0.024-193.896-86.831-193.92-193.918l-0-0.002c0-39.552 12.032-76.117 32.341-106.752z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['eye_hide'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59811,
    },
    {
      paths: [
        'M430.507 665.173l60.16 60.16 213.333-213.333-213.333-213.333-60.16 60.16 110.080 110.507h-412.587v85.333h412.587l-110.080 110.507zM810.667 128h-597.333c-47.36 0-85.333 38.4-85.333 85.333v170.667h85.333v-170.667h597.333v597.333h-597.333v-170.667h-85.333v170.667c0 46.933 37.973 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['exit'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59668,
    },
    {
      paths: [
        'M725.333 128h-426.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 682.667 298.667-128 298.667 128v-682.667c0-46.933-38.4-85.333-85.333-85.333zM725.333 768l-213.333-93.013-213.333 93.013v-554.667h426.667v554.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['bookmark'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59812,
    },
    {
      paths: [
        'M725.333 128h-426.667c-46.933 0-84.907 38.4-84.907 85.333l-0.427 682.667 298.667-128 298.667 128v-682.667c0-46.933-38.4-85.333-85.333-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['bookmark_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59813,
    },
    {
      paths: [
        'M938.667 394.24l-306.773-26.453-119.893-282.453-119.893 282.88-306.773 26.027 232.96 201.813-69.973 299.947 263.68-159.147 263.68 159.147-69.547-299.947 232.533-201.813zM512 657.067l-160.427 96.853 42.667-182.613-141.653-122.88 186.88-16.213 72.533-171.947 72.96 172.373 186.88 16.213-141.653 122.88 42.667 182.613-160.853-97.28z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['star'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59814,
    },
    {
      paths: [
        'M512 736.853l263.68 159.147-69.973-299.947 232.96-201.813-306.773-26.027-119.893-282.88-119.893 282.88-306.773 26.027 232.96 201.813-69.973 299.947z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['star_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59815,
    },
    {
      paths: [
        'M704 128c-74.24 0-145.493 34.56-192 89.173-46.507-54.613-117.76-89.173-192-89.173-131.413 0-234.667 103.253-234.667 234.667 0 161.28 145.067 292.693 364.8 492.373l61.867 55.893 61.867-56.32c219.733-199.253 364.8-330.667 364.8-491.947 0-131.413-103.253-234.667-234.667-234.667zM516.267 791.467l-4.267 4.267-4.267-4.267c-203.093-183.893-337.067-305.493-337.067-428.8 0-85.333 64-149.333 149.333-149.333 65.707 0 129.707 42.24 152.32 100.693h79.787c22.187-58.453 86.187-100.693 151.893-100.693 85.333 0 149.333 64 149.333 149.333 0 123.307-133.973 244.907-337.067 428.8z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['heart'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59816,
    },
    {
      paths: [
        'M512 910.933l-61.867-56.32c-219.733-199.253-364.8-330.667-364.8-491.947 0-131.413 103.253-234.667 234.667-234.667 74.24 0 145.493 34.56 192 89.173 46.507-54.613 117.76-89.173 192-89.173 131.413 0 234.667 103.253 234.667 234.667 0 161.28-145.067 292.693-364.8 492.373l-61.867 55.893z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['heart_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59817,
    },
    {
      paths: [
        'M128 725.333v85.333h256v-85.333h-256zM128 213.333v85.333h426.667v-85.333h-426.667zM554.667 896v-85.333h341.333v-85.333h-341.333v-85.333h-85.333v256h85.333zM298.667 384v85.333h-170.667v85.333h170.667v85.333h85.333v-256h-85.333zM896 554.667v-85.333h-426.667v85.333h426.667zM640 384h85.333v-85.333h170.667v-85.333h-170.667v-85.333h-85.333v256z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['tune'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59688,
    },
    {
      paths: [
        'M384 298.667h-85.333v85.333h85.333v-85.333zM384 469.333h-85.333v85.333h85.333v-85.333zM384 128c-47.36 0-85.333 38.4-85.333 85.333h85.333v-85.333zM554.667 640h-85.333v85.333h85.333v-85.333zM810.667 128v85.333h85.333c0-46.933-38.4-85.333-85.333-85.333zM554.667 128h-85.333v85.333h85.333v-85.333zM384 725.333v-85.333h-85.333c0 46.933 37.973 85.333 85.333 85.333zM810.667 554.667h85.333v-85.333h-85.333v85.333zM810.667 384h85.333v-85.333h-85.333v85.333zM810.667 725.333c46.933 0 85.333-38.4 85.333-85.333h-85.333v85.333zM213.333 298.667h-85.333v512c0 46.933 37.973 85.333 85.333 85.333h512v-85.333h-512v-512zM640 213.333h85.333v-85.333h-85.333v85.333zM640 725.333h85.333v-85.333h-85.333v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['flip'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59718,
    },
    {
      paths: [
        'M128 554.667h85.333v-85.333h-85.333v85.333zM128 725.333h85.333v-85.333h-85.333v85.333zM213.333 896v-85.333h-85.333c0 47.128 38.205 85.333 85.333 85.333v0zM128 384h85.333v-85.333h-85.333v85.333zM640 896h85.333v-85.333h-85.333v85.333zM810.667 128h-426.667c-47.128 0-85.333 38.205-85.333 85.333v0 426.667c0 47.128 38.205 85.333 85.333 85.333v0h426.667c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM810.667 640h-426.667v-426.667h426.667v426.667zM469.333 896h85.333v-85.333h-85.333v85.333zM298.667 896h85.333v-85.333h-85.333v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['flip_front'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59818,
    },
    {
      paths: [
        'M128 768h768v-85.333h-768v85.333zM128 554.667h768v-85.333h-768v85.333zM128 256v85.333h768v-85.333h-768z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['hamburger'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59672,
    },
    {
      paths: [
        'M469.333 768h85.333v-85.333h-85.333v85.333zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.16 0-341.333-153.173-341.333-341.333s153.173-341.333 341.333-341.333c188.16 0 341.333 153.173 341.333 341.333s-153.173 341.333-341.333 341.333zM512 256c-94.293 0-170.667 76.373-170.667 170.667h85.333c0-46.933 38.4-85.333 85.333-85.333s85.333 38.4 85.333 85.333c0 85.333-128 74.667-128 213.333h85.333c0-96 128-106.667 128-213.333 0-94.293-76.373-170.667-170.667-170.667z',
      ],
      grid: 0,
      tags: ['help'],
      defaultCode: 59673,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM554.667 810.667h-85.333v-85.333h85.333v85.333zM642.987 480l-38.4 39.253c-30.72 31.147-49.92 56.747-49.92 120.747h-85.333v-21.333c0-46.933 19.2-89.6 49.92-120.747l52.907-53.76c15.787-15.36 25.173-36.693 25.173-60.16 0-46.933-38.4-85.333-85.333-85.333s-85.333 38.4-85.333 85.333h-85.333c0-94.293 76.373-170.667 170.667-170.667s170.667 76.373 170.667 170.667c0 37.547-15.36 71.68-39.68 96z',
      ],
      grid: 0,
      tags: ['help_active'],
      defaultCode: 59721,
    },
    {
      paths: [
        'M224 128c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM224 416c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM224 704c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM800 320c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0zM512 704c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM800 704c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM800 416c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM512 416c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0zM512 128c-52.951 0.169-95.831 43.049-96 95.984l-0 0.016c0.169 52.951 43.049 95.831 95.984 96l0.016 0c52.951-0.169 95.831-43.049 96-95.984l0-0.016c-0.169-52.951-43.049-95.831-95.984-96l-0.016-0z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['line_of_business'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59819,
    },
    {
      paths: [
        'M810.667 810.667h-597.333v-597.333h298.667v-85.333h-298.667c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-298.667h-85.333v298.667zM597.333 128v85.333h153.173l-419.413 419.413 60.16 60.16 419.413-419.413v153.173h85.333v-298.667h-298.667z',
      ],
      grid: 0,
      tags: ['baseline-open_in_new-24px'],
      defaultCode: 59648,
    },
    {
      paths: [
        'M512 170.667v-128l-170.667 170.667 170.667 170.667v-128c141.227 0 256 114.773 256 256 0 43.093-10.667 84.053-29.867 119.467l62.293 62.293c33.28-52.48 52.907-114.773 52.907-181.76 0-188.587-152.747-341.333-341.333-341.333zM512 768c-141.227 0-256-114.773-256-256 0-43.093 10.667-84.053 29.867-119.467l-62.293-62.293c-33.28 52.48-52.907 114.773-52.907 181.76 0 188.587 152.747 341.333 341.333 341.333v128l170.667-170.667-170.667-170.667v128z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['loading'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59820,
    },
    {
      paths: [
        'M512 725.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM768 341.333h-42.667v-85.333c0-117.76-95.573-213.333-213.333-213.333s-213.333 95.573-213.333 213.333h81.067c0-72.96 59.307-132.267 132.267-132.267s132.267 59.307 132.267 132.267v85.333h-388.267c-46.933 0-85.333 38.4-85.333 85.333v426.667c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM768 853.333h-512v-426.667h512v426.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['unlock'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59821,
    },
    {
      paths: [
        'M768 341.333h-42.667v-85.333c0-117.76-95.573-213.333-213.333-213.333s-213.333 95.573-213.333 213.333v85.333h-42.667c-46.933 0-85.333 38.4-85.333 85.333v426.667c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM384 256c0-70.827 57.173-128 128-128s128 57.173 128 128v85.333h-256v-85.333zM768 853.333h-512v-426.667h512v426.667zM512 725.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['lock'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59822,
    },
    {
      paths: [
        'M768 341.333h-42.667v-85.333c0-117.76-95.573-213.333-213.333-213.333s-213.333 95.573-213.333 213.333v85.333h-42.667c-46.933 0-85.333 38.4-85.333 85.333v426.667c0 46.933 38.4 85.333 85.333 85.333h512c46.933 0 85.333-38.4 85.333-85.333v-426.667c0-46.933-38.4-85.333-85.333-85.333zM512 725.333c-46.933 0-85.333-38.4-85.333-85.333s38.4-85.333 85.333-85.333 85.333 38.4 85.333 85.333-38.4 85.333-85.333 85.333zM644.267 341.333h-264.533v-85.333c0-72.96 59.307-132.267 132.267-132.267s132.267 59.307 132.267 132.267v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['lock_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59823,
    },
    {
      paths: [
        'M512 341.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333-85.333 38.4-85.333 85.333 38.4 85.333 85.333 85.333zM512 426.667c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333zM512 682.667c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333 85.333-38.4 85.333-85.333-38.4-85.333-85.333-85.333z',
      ],
      grid: 0,
      tags: ['outline-more_vert-24px'],
      defaultCode: 59766,
    },
    {
      paths: [
        'M384 682.667h85.333v-341.333h-85.333v341.333zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.16 0-341.333-153.173-341.333-341.333s153.173-341.333 341.333-341.333c188.16 0 341.333 153.173 341.333 341.333s-153.173 341.333-341.333 341.333zM554.667 682.667h85.333v-341.333h-85.333v341.333z',
      ],
      grid: 0,
      tags: ['resting@2x'],
      defaultCode: 59754,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM469.333 682.667h-85.333v-341.333h85.333v341.333zM640 682.667h-85.333v-341.333h85.333v341.333z',
      ],
      grid: 0,
      tags: ['active@2x'],
      defaultCode: 59753,
    },
    {
      paths: [
        'M810.667 341.333h-42.667v-213.333h-512v213.333h-42.667c-70.827 0-128 57.173-128 128v256h170.667v170.667h512v-170.667h170.667v-256c0-70.827-57.173-128-128-128zM341.333 213.333h341.333v128h-341.333v-128zM682.667 725.333v85.333h-341.333v-170.667h341.333v85.333zM768 640v-85.333h-512v85.333h-85.333v-170.667c0-23.467 19.2-42.667 42.667-42.667h597.333c23.467 0 42.667 19.2 42.667 42.667v170.667h-85.333z',
        'M810.667 490.667c0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667c0-23.564 19.103-42.667 42.667-42.667s42.667 19.103 42.667 42.667z',
      ],
      grid: 0,
      tags: ['print'],
      defaultCode: 59757,
    },
    {
      paths: [
        'M810.667 341.333h-597.333c-70.827 0-128 57.173-128 128v256h170.667v170.667h512v-170.667h170.667v-256c0-70.827-57.173-128-128-128zM682.667 810.667h-341.333v-213.333h341.333v213.333zM810.667 512c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667 42.667 19.2 42.667 42.667-19.2 42.667-42.667 42.667zM768 128h-512v170.667h512v-170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['print_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59824,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333s152.747-341.333 341.333-341.333c188.587 0 341.333 152.747 341.333 341.333s-152.747 341.333-341.333 341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['radio'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59683,
    },
    {
      paths: [
        'M512 298.667c-117.76 0-213.333 95.573-213.333 213.333s95.573 213.333 213.333 213.333c117.76 0 213.333-95.573 213.333-213.333s-95.573-213.333-213.333-213.333zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333s152.747-341.333 341.333-341.333c188.587 0 341.333 152.747 341.333 341.333s-152.747 341.333-341.333 341.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['radio_active'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59739,
    },
    {
      paths: [
        'M426.667 384v-170.667l-298.667 298.667 298.667 298.667v-174.933c213.333 0 362.667 68.267 469.333 217.6-42.667-213.333-170.667-426.667-469.333-469.333z',
      ],
      grid: 0,
      tags: ['reply'],
      defaultCode: 59740,
    },
    {
      paths: [
        'M661.333 597.333h-33.707l-11.947-11.52c41.813-48.64 66.987-111.787 66.987-180.48 0-153.173-124.16-277.333-277.333-277.333s-277.333 124.16-277.333 277.333c0 153.173 124.16 277.333 277.333 277.333 68.693 0 131.84-25.173 180.48-66.987l11.52 11.947v33.707l213.333 212.907 63.573-63.573-212.907-213.333zM405.333 597.333c-106.24 0-192-85.76-192-192s85.76-192 192-192c106.24 0 192 85.76 192 192s-85.76 192-192 192z',
      ],
      grid: 0,
      tags: ['search'],
      defaultCode: 59684,
    },
    {
      paths: [
        'M85.76 896l895.573-384-895.573-384-0.427 298.667 640 85.333-640 85.333z',
      ],
      grid: 0,
      tags: ['send'],
      defaultCode: 59741,
    },
    {
      paths: [
        'M768 686.080c-32.427 0-61.44 12.8-83.627 32.853l-304.213-177.067c2.133-9.813 3.84-19.627 3.84-29.867s-1.707-20.053-3.84-29.867l300.8-175.36c23.040 21.333 53.333 34.56 87.040 34.56 70.827 0 128-57.173 128-128s-57.173-128-128-128c-70.827 0-128 57.173-128 128 0 10.24 1.707 20.053 3.84 29.867l-300.8 175.36c-23.040-21.333-53.333-34.56-87.040-34.56-70.827 0-128 57.173-128 128s57.173 128 128 128c33.707 0 64-13.227 87.040-34.56l303.787 177.493c-2.133 8.96-3.413 18.347-3.413 27.733 0 68.693 55.893 124.587 124.587 124.587s124.587-55.893 124.587-124.587c0-68.693-55.893-124.587-124.587-124.587zM768 170.667c23.467 0 42.667 19.2 42.667 42.667s-19.2 42.667-42.667 42.667c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667zM256 554.667c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667c23.467 0 42.667 19.2 42.667 42.667s-19.2 42.667-42.667 42.667zM768 854.187c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667c23.467 0 42.667 19.2 42.667 42.667s-19.2 42.667-42.667 42.667z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['share'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59686,
    },
    {
      paths: [
        'M768 686.080c-32.427 0-61.44 12.8-83.627 32.853l-304.213-177.067c2.133-9.813 3.84-19.627 3.84-29.867s-1.707-20.053-3.84-29.867l300.8-175.36c23.040 21.333 53.333 34.56 87.040 34.56 70.827 0 128-57.173 128-128s-57.173-128-128-128c-70.827 0-128 57.173-128 128 0 10.24 1.707 20.053 3.84 29.867l-300.8 175.36c-23.040-21.333-53.333-34.56-87.040-34.56-70.827 0-128 57.173-128 128s57.173 128 128 128c33.707 0 64-13.227 87.040-34.56l303.787 177.493c-2.133 8.96-3.413 18.347-3.413 27.733 0 68.693 55.893 124.587 124.587 124.587s124.587-55.893 124.587-124.587c0-68.693-55.893-124.587-124.587-124.587z',
      ],
      grid: 0,
      tags: ['share_active'],
      defaultCode: 59743,
    },
    {
      paths: [
        'M511.573 640h89.173l-218.027-554.667h-79.36l-218.027 554.667h89.173l47.787-128h240.64l48.64 128zM254.72 426.667l88.32-235.52 88.32 235.52h-176.64zM901.547 451.84l-345.173 345.173-156.587-157.013-60.16 60.16 217.173 217.173 404.907-405.333-60.16-60.16z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['spellcheck'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59825,
    },
    {
      paths: [
        'M426.667 768h170.667v-85.333h-170.667v85.333zM128 256v85.333h768v-85.333h-768zM256 554.667h512v-85.333h-512v85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['sort'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59826,
    },
    {
      paths: ['M810.667 554.667h-597.333v-85.333h597.333v85.333z'],
      grid: 0,
      tags: ['baseline-remove-24px'],
      defaultCode: 59663,
    },
    {
      paths: [
        'M810.667 213.333v597.333h-597.333v-597.333h597.333zM857.6 128h-691.2c-21.333 0-38.4 17.067-38.4 38.4v691.2c0 17.067 17.067 38.4 38.4 38.4h691.2c17.067 0 38.4-21.333 38.4-38.4v-691.2c0-21.333-21.333-38.4-38.4-38.4zM469.333 298.667h256v85.333h-256v-85.333zM469.333 469.333h256v85.333h-256v-85.333zM469.333 640h256v85.333h-256v-85.333zM298.667 298.667h85.333v85.333h-85.333v-85.333zM298.667 469.333h85.333v85.333h-85.333v-85.333zM298.667 640h85.333v85.333h-85.333v-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['stepper'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59827,
    },
    {
      paths: [
        'M170.667 512h213.333v-256h-213.333v256zM170.667 810.667h213.333v-256h-213.333v256zM426.667 810.667h213.333v-256h-213.333v256zM682.667 810.667h213.333v-256h-213.333v256zM426.667 512h213.333v-256h-213.333v256zM682.667 256v256h213.333v-256h-213.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['table'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59828,
    },
    {
      paths: [
        'M469.333 298.667h85.333v85.333h-85.333v-85.333zM469.333 469.333h85.333v256h-85.333v-256zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.16 0-341.333-153.173-341.333-341.333s153.173-341.333 341.333-341.333c188.16 0 341.333 153.173 341.333 341.333s-153.173 341.333-341.333 341.333z',
      ],
      grid: 0,
      tags: ['info'],
      defaultCode: 59676,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM554.667 725.333h-85.333v-256h85.333v256zM554.667 384h-85.333v-85.333h85.333v85.333z',
      ],
      grid: 0,
      tags: ['info_active'],
      defaultCode: 59726,
    },
    {
      paths: [
        'M533.333 341.333c-113.067 0-215.467 42.24-294.4 110.933l-153.6-153.6v384h384l-154.453-154.453c59.307-49.493 134.827-80.213 218.453-80.213 151.040 0 279.467 98.56 324.267 234.667l101.12-33.28c-59.307-178.773-226.987-308.053-425.387-308.053z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['undo'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59829,
    },
    {
      paths: [
        'M298.667 793.173l60.587 60.16 135.253-135.253 135.253 135.253 60.16-60.16-195.413-195.84-195.84 195.84zM690.347 230.827l-60.587-60.16-135.253 135.253-135.253-135.253-60.587 60.16 195.84 195.84 195.84-195.84z',
      ],
      grid: 0,
      tags: ['unfold_less'],
      defaultCode: 59749,
    },
    {
      paths: [
        'M494.507 248.747l135.253 135.253 60.16-60.16-195.413-195.84-195.84 195.84 60.587 60.16 135.253-135.253zM494.507 775.253l-135.253-135.253-60.16 60.16 195.413 195.84 195.84-195.84-60.587-60.16-135.253 135.253z',
      ],
      grid: 0,
      tags: ['unfold_more'],
      defaultCode: 59750,
    },
    {
      paths: [
        'M469.333 597.333v-256h-49.92l92.587-92.587 92.587 92.587h-49.92v256h-85.333zM384 682.667h256v-256h170.667l-298.667-298.667-298.667 298.667h170.667v256zM810.667 768h-597.333v85.333h597.333v-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['resting@2x'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59763,
    },
    {
      paths: [
        'M213.333 426.667h170.667v256h256v-256h170.667l-298.667-298.667-298.667 298.667zM213.333 768v85.333h597.333v-85.333h-597.333z',
      ],
      grid: 0,
      tags: ['active@2x'],
      defaultCode: 59762,
    },
    {
      paths: [
        'M825.6 428.373c-29.013-147.2-158.293-257.707-313.6-257.707-123.307 0-230.4 69.973-283.733 172.373-128.427 13.653-228.267 122.453-228.267 254.293 0 141.227 114.773 256 256 256h554.667c117.76 0 213.333-95.573 213.333-213.333 0-112.64-87.467-203.947-198.4-211.627zM810.667 768h-554.667c-94.293 0-170.667-76.373-170.667-170.667 0-87.467 65.28-160.427 151.893-169.387l45.653-4.693 21.333-40.533c40.533-78.080 119.893-126.72 207.787-126.72 111.787 0 208.213 79.36 229.973 189.013l12.8 64 65.28 4.693c66.56 4.267 118.613 60.16 118.613 126.293 0 70.4-57.6 128-128 128zM341.333 554.667h108.8v128h123.733v-128h108.8l-170.667-170.667z',
      ],
      grid: 0,
      tags: ['outline-cloud_upload-24px'],
      defaultCode: 59767,
    },
    {
      paths: [
        'M825.6 428.373c-29.96-147.919-158.923-257.707-313.528-257.707-0.025 0-0.051 0-0.076 0l0.004-0c-123.307 0-230.4 69.973-283.733 172.373-128.922 14.339-228.267 122.7-228.267 254.264 0 0.010 0 0.021 0 0.031l-0-0.001c0 141.227 114.773 256 256 256h554.667c117.76 0 213.333-95.573 213.333-213.333 0-112.64-87.467-203.947-198.4-211.627zM597.333 554.667v170.667h-170.667v-170.667h-128l213.333-213.333 213.333 213.333h-128z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['upload_cloud_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59831,
    },
    {
      paths: [
        'M640 128h-384c-35.413 0-65.707 21.333-78.507 52.053l-128.853 300.8c-3.84 9.813-5.973 20.053-5.973 31.147v85.333c0 46.933 38.4 85.333 85.333 85.333h269.227l-40.533 194.987-1.28 13.653c0 17.493 7.253 33.707 18.773 45.227l45.227 44.8 281.173-281.173c15.36-15.36 24.747-36.693 24.747-60.16v-426.667c0-46.933-38.4-85.333-85.333-85.333zM640 640l-185.173 185.173 57.173-227.84h-384v-85.333l128-298.667h384v426.667zM810.667 128h170.667v512h-170.667z',
      ],
      grid: 0,
      tags: ['outline-thumb_down-24px'],
      defaultCode: 59758,
    },
    {
      paths: [
        'M640 128h-384c-35.413 0-65.707 21.333-78.507 52.053l-128.853 300.8c-3.84 9.813-5.973 20.053-5.973 31.147v85.333c0 46.933 38.4 85.333 85.333 85.333h269.227l-40.533 194.987-1.28 13.653c0 17.493 7.253 33.707 18.773 45.227l45.227 44.8 281.173-281.173c15.36-15.36 24.747-36.693 24.747-60.16v-426.667c0-46.933-38.4-85.333-85.333-85.333zM810.667 128v512h170.667v-512h-170.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['thumbs_down_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59840,
    },
    {
      paths: [
        'M384 896h384c35.413 0 65.707-21.333 78.507-52.053l128.853-300.8c3.84-9.813 5.973-20.053 5.973-31.147v-85.333c0-46.933-38.4-85.333-85.333-85.333h-269.227l40.533-194.987 1.28-13.653c0-17.493-7.253-33.707-18.773-45.227l-45.227-44.8-281.173 281.173c-15.36 15.36-24.747 36.693-24.747 60.16v426.667c0 46.933 38.4 85.333 85.333 85.333zM384 384l185.173-185.173-57.173 227.84h384v85.333l-128 298.667h-384v-426.667zM42.667 384h170.667v512h-170.667z',
      ],
      grid: 0,
      tags: ['outline-thumb_up-24px'],
      defaultCode: 59759,
    },
    {
      paths: [
        'M42.667 896h170.667v-512h-170.667v512zM981.333 426.667c0-46.933-38.4-85.333-85.333-85.333h-269.227l40.533-194.987 1.28-13.653c0-17.493-7.253-33.707-18.773-45.227l-45.227-44.8-280.747 281.173c-15.787 15.36-25.173 36.693-25.173 60.16v426.667c0 46.933 38.4 85.333 85.333 85.333h384c35.413 0 65.707-21.333 78.507-52.053l128.853-300.8c3.84-9.813 5.973-20.053 5.973-31.147v-85.333z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['thumbs_up_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59841,
    },
    {
      paths: [
        'M707.84 323.413l-281.173 281.173-153.173-152.747-60.16 60.16 213.333 213.333 341.333-341.333-60.16-60.587zM512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333s152.747-341.333 341.333-341.333c188.587 0 341.333 152.747 341.333 341.333s-152.747 341.333-341.333 341.333z',
      ],
      grid: 0,
      tags: ['resting@2x'],
      defaultCode: 59756,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM426.667 725.333l-213.333-213.333 60.16-60.16 153.173 152.747 323.84-323.84 60.16 60.587-384 384z',
      ],
      grid: 0,
      tags: ['active@2x'],
      defaultCode: 59755,
    },
    {
      paths: [
        'M384 689.92l-177.92-177.92-60.587 60.16 238.507 238.507 512-512-60.16-60.16z',
      ],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['check'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59654,
    },
    {
      paths: [
        'M17.493 572.16l238.507 238.507 60.16-60.16-238.080-238.507zM768 298.667l-60.16-60.16-270.507 270.507 60.16 60.16z',
        'M948.907 238.507l-451.413 451.413-178.347-177.92-60.16 60.16 238.507 238.507 512-512z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['double_check'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59842,
    },
    {
      paths: [
        'M469.333 640h85.333v85.333h-85.333v-85.333zM469.333 298.667h85.333v256h-85.333v-256zM511.573 85.333c-235.52 0-426.24 191.147-426.24 426.667s190.72 426.667 426.24 426.667c235.947 0 427.093-191.147 427.093-426.667s-191.147-426.667-427.093-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333s152.747-341.333 341.333-341.333c188.587 0 341.333 152.747 341.333 341.333s-152.747 341.333-341.333 341.333z',
      ],
      grid: 0,
      tags: ['error'],
      defaultCode: 59667,
    },
    {
      paths: [
        'M512 85.333c-235.52 0-426.667 191.147-426.667 426.667s191.147 426.667 426.667 426.667c235.52 0 426.667-191.147 426.667-426.667s-191.147-426.667-426.667-426.667zM554.667 725.333h-85.333v-85.333h85.333v85.333zM554.667 554.667h-85.333v-256h85.333v256z',
      ],
      grid: 0,
      tags: ['error_active'],
      defaultCode: 59716,
    },
    {
      paths: [
        'M597.333 256l-42.667-85.333h-341.333v725.333h85.333v-298.667h213.333l42.667 85.333h298.667v-426.667h-256zM768 597.333h-170.667l-42.667-85.333h-256v-256h213.333l42.667 85.333h213.333v256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['flag'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59843,
    },
    {
      paths: [
        'M614.4 256l-17.067-85.333h-384v725.333h85.333v-298.667h238.933l17.067 85.333h298.667v-426.667z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['flag_active'],
      colorPermutations: {
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59844,
    },
    {
      paths: ['M419.84 475.136h184.32v85.333h-184.32z'],
      attrs: [
        {
          fill: 'rgb(74, 74, 74)',
        },
      ],
      grid: 0,
      tags: ['bullet'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 1,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 1,
          },
        ],
      },
      defaultCode: 59651,
    },
    {
      paths: [
        'M511.573 85.333c-235.52 0-426.24 191.147-426.24 426.667s190.72 426.667 426.24 426.667c235.947 0 427.093-191.147 427.093-426.667s-191.147-426.667-427.093-426.667zM512 853.333c-188.587 0-341.333-152.747-341.333-341.333s152.747-341.333 341.333-341.333c188.587 0 341.333 152.747 341.333 341.333s-152.747 341.333-341.333 341.333zM661.333 469.333c35.413 0 64-28.587 64-64s-28.587-64-64-64c-35.413 0-64 28.587-64 64s28.587 64 64 64zM362.667 469.333c35.413 0 64-28.587 64-64s-28.587-64-64-64c-35.413 0-64 28.587-64 64s28.587 64 64 64zM512 746.667c99.413 0 183.893-62.293 218.027-149.333h-436.053c34.133 87.040 118.613 149.333 218.027 149.333z',
      ],
      grid: 0,
      tags: ['face'],
      defaultCode: 59669,
    },
    {
      paths: [
        'M42.667 896h938.667l-469.333-810.667-469.333 810.667zM554.667 768h-85.333v-85.333h85.333v85.333zM554.667 597.333h-85.333v-170.667h85.333v170.667z',
      ],
      grid: 0,
      tags: ['baseline-warning-24px'],
      defaultCode: 59773,
    },
    {
      paths: [
        'M486.827 316.16l-60.16-60.16-256 256 256 256 60.16-60.16-195.413-195.84z',
        'M828.16 316.16l-60.16-60.16-256 256 256 256 60.16-60.16-195.413-195.84z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['left-double'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59671,
    },
    {
      paths: [
        'M230.827 256l-60.16 60.16 195.413 195.84-195.413 195.84 60.16 60.16 256-256z',
        'M572.16 256l-60.16 60.16 195.413 195.84-195.413 195.84 60.16 60.16 256-256z',
      ],
      attrs: [
        {
          fill: 'rgb(12, 34, 80)',
        },
        {
          fill: 'rgb(12, 34, 80)',
        },
      ],
      grid: 0,
      tags: ['right-double'],
      colorPermutations: {
        '12810122117474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
        '1234801236238240125525525517474741': [
          {
            f: 0,
          },
          {
            f: 0,
          },
        ],
      },
      defaultCode: 59772,
    },
  ],
  colorThemes: [
    [
      [0, 0, 0, 1],
      [74, 74, 74, 1],
      [28, 101, 221, 1],
    ],
    [
      [12, 34, 80, 1],
      [74, 74, 74, 1],
      [236, 238, 240, 1],
      [255, 255, 255, 1],
    ],
  ],
  colorThemeIdx: 1,
  preferences: {
    showGlyphs: true,
    showQuickUse: true,
    showQuickUse2: false,
    showSVGs: true,
    fontPref: {
      prefix: '',
      metadata: {
        fontFamily: 'product-icons',
        majorVersion: 1,
        minorVersion: 0,
      },
      metrics: {
        emSize: 1024,
        baseline: 20,
        whitespace: 0,
      },
      embed: false,
      showSelector: true,
      selector: 'i',
      autoHost: false,
      showMetrics: false,
      showMetadata: false,
      resetPoint: 59648,
      ligaReset: 'names',
      noie8: true,
      ie7: false,
    },
    imagePref: {
      prefix: 'icon-',
      png: true,
      useClassSelector: true,
      color: 0,
      bgColor: 16777215,
      classSelector: '.icon',
      name: 'icomoon',
      height: 32,
      columns: 16,
      margin: 16,
    },
    historySize: 50,
    showCodes: false,
    gridSize: 16,
    showLiga: true,
    quickUsageToken: {
      UntitledProject:
        'NTQxYzcwMDQ1OTcwYzAwMTA3NTMyYWM2NmJmNjNmMWQjMSMxNTQ2ODgyMDc5IyMj',
    },
  },
  IcoMoonType: 'icon-set',
};

tempIcons.selection.sort((a, b) =>
  a.name < b.name ? -1 : a.name > b.name ? 1 : 0,
);
tempIcons.selection.forEach((icon) => {
  ICON_DROPDOWN_OPTIONS.push({
    label: icon.name
      .replace(/_active/g, ' — active ')
      .replace(/_/g, ' ')
      .replace(/(?: |\b)(\w)/g, function (key) {
        return key.toUpperCase();
      }),
    value: icon.name,
  });
});
